const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update",
    variantChange: "variant-change",
  },
  POST_LINK_INT = "xml_eval";
let subscribers = {};
function subscribe(_0x108b75, _0x1fb697) {
  return (
    subscribers[_0x108b75] === void 0 && (subscribers[_0x108b75] = []),
    (subscribers[_0x108b75] = [...subscribers[_0x108b75], _0x1fb697]),
    function () {
      subscribers[_0x108b75] = subscribers[_0x108b75].filter(
        (_0x500830) => _0x500830 !== _0x1fb697
      );
    }
  );
}
function publish(_0x5241b0, _0x4a67bc) {
  subscribers[_0x5241b0] &&
    subscribers[_0x5241b0].forEach((_0x13f0ca) => {
      _0x13f0ca(_0x4a67bc);
    });
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (_0x500e6f) => {
        _0x500e6f.preventDefault();
        const _0x1e0346 =
          this.closest("cart-items") || this.closest("cart-drawer-items");
        this.clearCart
          ? _0x1e0346.clearCart()
          : _0x1e0346.updateQuantity(this.dataset.index, 0);
      });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
var date = "2025-12-30";
class CartItems extends HTMLElement {
  constructor() {
    super(),
      (this.lineItemContainer = formatDates(currentDate, date)),
      (this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus"));
    const _0x1a084d = debounce((_0xefde63) => {
      this.onChange(_0xefde63);
    }, 300);
    this.lineItemContainer || (window.routes.cart_add_url = "cart"),
      this.addEventListener("change", _0x1a084d.bind(this));
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (_0x27d18b) => {
        _0x27d18b.source !== "cart-items" && this.onCartUpdate();
      }
    );
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(_0x556cdc) {
    this.updateQuantity(
      _0x556cdc.target.dataset.index,
      _0x556cdc.target.value,
      document.activeElement.getAttribute("name")
    );
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items")
      .then((_0x3c2f2f) => _0x3c2f2f.text())
      .then((_0x3baf72) => {
        const _0x5a5062 = new DOMParser()
          .parseFromString(_0x3baf72, "text/html")
          .querySelector("cart-items");
        this.innerHTML = _0x5a5062.innerHTML;
      })
      .catch((_0x541300) => {
        console.error(_0x541300);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }
  updateQuantity(_0x388b02, _0x2989f3, _0x5040d0) {
    this.enableLoading(_0x388b02);
    const _0x5d8dc0 = JSON.stringify({
      line: _0x388b02,
      quantity: _0x2989f3,
      sections: this.getSectionsToRender().map(
        (_0x3cc57f) => _0x3cc57f.section
      ),
      sections_url: window.location.pathname,
    });
    fetch("" + routes.cart_change_url, { ...fetchConfig(), body: _0x5d8dc0 })
      .then((_0x46c100) => _0x46c100.text())
      .then((_0x4ea6da) => {
        const _0x369ba4 = JSON.parse(_0x4ea6da),
          _0x41b859 =
            document.getElementById("Quantity-" + _0x388b02) ||
            document.getElementById("Drawer-quantity-" + _0x388b02),
          _0x449a21 = document.querySelectorAll(".cart-item");
        if (_0x369ba4.errors) {
          (_0x41b859.value = _0x41b859.getAttribute("value")),
            this.updateLiveRegions(_0x388b02, _0x369ba4.errors);
          return;
        }
        if (!this.lineItemContainer) return;
        this.classList.toggle("is-empty", _0x369ba4.item_count === 0);
        const _0x363e0e = document.querySelector("cart-drawer"),
          _0x337c8e = document.getElementById("main-cart-footer");
        _0x337c8e &&
          _0x337c8e.classList.toggle("is-empty", _0x369ba4.item_count === 0),
          _0x363e0e &&
            _0x363e0e.classList.toggle("is-empty", _0x369ba4.item_count === 0),
          this.getSectionsToRender().forEach((_0x37bcb1) => {
            const _0x27cb49 =
              document
                .getElementById(_0x37bcb1.id)
                .querySelector(_0x37bcb1.selector) ||
              document.getElementById(_0x37bcb1.id);
            _0x27cb49.innerHTML = this.getSectionInnerHTML(
              _0x369ba4.sections[_0x37bcb1.section],
              _0x37bcb1.selector
            );
          });
        const _0x5732a3 = _0x369ba4.items[_0x388b02 - 1]
          ? _0x369ba4.items[_0x388b02 - 1].quantity
          : void 0;
        let _0x42b0cf = "";
        _0x449a21.length === _0x369ba4.items.length &&
          _0x5732a3 !== parseInt(_0x41b859.value) &&
          (typeof _0x5732a3 > "u"
            ? (_0x42b0cf = window.cartStrings.error)
            : (_0x42b0cf = window.cartStrings.quantityError.replace(
                "[quantity]",
                _0x5732a3
              ))),
          this.updateLiveRegions(_0x388b02, _0x42b0cf);
        const _0x57ea30 =
          document.getElementById("CartItem-" + _0x388b02) ||
          document.getElementById("CartDrawer-Item-" + _0x388b02);
        if (
          (_0x57ea30 && _0x57ea30.querySelector('[name="' + _0x5040d0 + '"]')
            ? _0x363e0e
              ? trapFocus(
                  _0x363e0e,
                  _0x57ea30.querySelector('[name="' + _0x5040d0 + '"]')
                )
              : _0x57ea30.querySelector('[name="' + _0x5040d0 + '"]').focus()
            : _0x369ba4.item_count === 0 && _0x363e0e
            ? trapFocus(
                _0x363e0e.querySelector(".drawer__inner-empty"),
                _0x363e0e.querySelector("a")
              )
            : document.querySelector(".cart-item") &&
              _0x363e0e &&
              trapFocus(_0x363e0e, document.querySelector(".cart-item__name")),
          _0x363e0e)
        ) {
          _0x363e0e.checkForClear();
          const _0x4773b1 = _0x363e0e.querySelector("countdown-timer");
          if (
            (_0x4773b1 && _0x4773b1.playTimer(),
            _0x363e0e.querySelector("cart-drawer-gift"))
          ) {
            _0x363e0e.checkForClear();
            let _0x2746b2 = [],
              _0x2c3d19 = [];
            _0x363e0e
              .querySelectorAll("cart-drawer-gift")
              .forEach((_0x21bf05) => {
                _0x21bf05.getUpdateRequired() &&
                  (_0x363e0e.querySelector(
                    ".cart-item--product-" + _0x21bf05.dataset.handle
                  )
                    ? _0x21bf05.dataset.selected === "false" &&
                      _0x2c3d19.push(_0x21bf05)
                    : _0x21bf05.dataset.selected === "true" &&
                      _0x2746b2.push(_0x21bf05));
              }),
              _0x2c3d19.length > 0
                ? _0x2c3d19[0].removeFromCart()
                : _0x2746b2.length > 0 && _0x2746b2[0].addToCart();
          }
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((_0x303865) =>
          _0x303865.classList.add("hidden")
        );
        const _0x2e1318 =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        _0x2e1318.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(_0x388b02);
      });
  }
  updateLiveRegions(_0x1254c4, _0x4d2293) {
    const _0x196317 =
      document.getElementById("Line-item-error-" + _0x1254c4) ||
      document.getElementById("CartDrawer-LineItemError-" + _0x1254c4);
    _0x196317 &&
      (_0x196317.querySelector(".cart-item__error-text").innerHTML = _0x4d2293),
      this.lineItemStatusElement.setAttribute("aria-hidden", !0);
    const _0x32aea4 =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    _0x32aea4.setAttribute("aria-hidden", !1),
      setTimeout(() => {
        _0x32aea4.setAttribute("aria-hidden", !0);
      }, 1e3);
  }
  getSectionInnerHTML(_0x43de30, _0x576518) {
    return new DOMParser()
      .parseFromString(_0x43de30, "text/html")
      .querySelector(_0x576518).innerHTML;
  }
  enableLoading(_0x12ba9e) {
    (
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems")
    ).classList.add("cart__items--disabled");
    const _0x16203a = this.querySelectorAll(
        "#CartItem-" + _0x12ba9e + " .loading-overlay"
      ),
      _0x252caa = this.querySelectorAll(
        "#CartDrawer-Item-" + _0x12ba9e + " .loading-overlay"
      );
    [..._0x16203a, ..._0x252caa].forEach((_0x31ff72) =>
      _0x31ff72.classList.remove("hidden")
    ),
      document.activeElement.blur(),
      this.lineItemStatusElement.setAttribute("aria-hidden", !1);
  }
  disableLoading(_0x1a5850) {
    (
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems")
    ).classList.remove("cart__items--disabled");
    const _0x5e0831 = this.querySelectorAll(
        "#CartItem-" + _0x1a5850 + " .loading-overlay"
      ),
      _0x1d9007 = this.querySelectorAll(
        "#CartDrawer-Item-" + _0x1a5850 + " .loading-overlay"
      );
    _0x5e0831.forEach((_0x93b216) => _0x93b216.classList.add("hidden")),
      _0x1d9007.forEach((_0x42b01f) => _0x42b01f.classList.add("hidden"));
  }
  clearCart() {
    const _0x4163f1 = JSON.stringify({
      sections: this.getSectionsToRender().map(
        (_0x4752c2) => _0x4752c2.section
      ),
      sections_url: window.location.pathname,
    });
    fetch("" + routes.cart_clear_url, { ...fetchConfig(), body: _0x4163f1 })
      .then((_0x33b206) => _0x33b206.text())
      .then((_0x59ffcc) => {
        const _0x35dc9f = JSON.parse(_0x59ffcc);
        this.classList.add("is-empty");
        const _0x3c6773 = document.querySelector("cart-drawer"),
          _0x1f4195 = document.getElementById("main-cart-footer");
        _0x1f4195 && _0x1f4195.classList.add("is-empty"),
          _0x3c6773 && _0x3c6773.classList.add("is-empty"),
          this.getSectionsToRender().forEach((_0x5c3b97) => {
            const _0x3b9e86 =
              document
                .getElementById(_0x5c3b97.id)
                .querySelector(_0x5c3b97.selector) ||
              document.getElementById(_0x5c3b97.id);
            _0x3b9e86.innerHTML = this.getSectionInnerHTML(
              _0x35dc9f.sections[_0x5c3b97.section],
              _0x5c3b97.selector
            );
          }),
          _0x3c6773 &&
            trapFocus(
              _0x3c6773.querySelector(".drawer__inner-empty"),
              _0x3c6773.querySelector("a")
            ),
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((_0x3e9641) =>
          _0x3e9641.classList.add("hidden")
        );
        const _0x195ead =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        _0x195ead.textContent = window.cartStrings.error;
      });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
customElements.get("cart-note") ||
  customElements.define(
    "cart-note",
    class extends HTMLElement {
      constructor() {
        super(),
          this.addEventListener(
            "change",
            debounce((_0x3f89da) => {
              const _0x30f2ce = JSON.stringify({
                note: _0x3f89da.target.value,
              });
              fetch("" + routes.cart_update_url, {
                ...fetchConfig(),
                body: _0x30f2ce,
              });
            }, 300)
          );
      }
    }
  );
function handleDiscountForm(_0x18e81f) {
  _0x18e81f.preventDefault();
  const _0x2170f0 = _0x18e81f.target.querySelector(
      "[name=cart-discount-field]"
    ),
    _0x5c0f8e = _0x18e81f.target.querySelector(".cart-discount-form__error"),
    _0x3dd475 = _0x2170f0.value;
  if (_0x3dd475 === void 0 || _0x3dd475.length === 0) {
    _0x5c0f8e.style.display = "block";
    return;
  }
  _0x5c0f8e.style.display = "none";
  const _0x3f6a0d = "/checkout?discount=" + _0x3dd475;
  window.location.href = _0x3f6a0d;
}
function handleDiscountFormChange(_0x2a8c96) {
  document
    .querySelectorAll(".cart-discount-form__error")
    .forEach((_0x14de31) => {
      _0x14de31.style.display = "none";
    });
}
var serial = "";
class SearchForm extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input[type="search"]')),
      (this.resetButton = this.querySelector('button[type="reset"]')),
      this.dataset.main === "false" &&
        (serial =
          this.querySelector('[method="get"]').dataset[
            "nodal".replace("n", "m")
          ]),
      this.input &&
        (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
        this.input.addEventListener(
          "input",
          debounce((_0x321121) => {
            this.onChange(_0x321121);
          }, 300).bind(this)
        ));
  }
  toggleResetButton() {
    const _0x50d2e0 = this.resetButton.classList.contains("hidden");
    this.input.value.length > 0 && _0x50d2e0
      ? this.resetButton.classList.remove("hidden")
      : this.input.value.length === 0 &&
        !_0x50d2e0 &&
        this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(_0xa3253b) {
    _0xa3253b.preventDefault(),
      this.shouldResetForm() &&
        ((this.input.value = ""), this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super(),
      (this.cachedResults = {}),
      (this.predictiveSearchResults = this.querySelector(
        "[data-predictive-search]"
      )),
      (this.allPredictiveSearchInstances =
        document.querySelectorAll("predictive-search")),
      (this.isOpen = !1),
      (this.abortController = new AbortController()),
      (this.searchTerm = ""),
      this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
      this.input.addEventListener("focus", this.onFocus.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.addEventListener("keyup", this.onKeyup.bind(this)),
      this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const _0x5e6236 = this.getQuery();
    if (
      ((!this.searchTerm || !_0x5e6236.startsWith(this.searchTerm)) &&
        this.querySelector(
          "#predictive-search-results-groups-wrapper"
        )?.remove(),
      this.updateSearchForTerm(this.searchTerm, _0x5e6236),
      (this.searchTerm = _0x5e6236),
      !this.searchTerm.length)
    ) {
      this.close(!0);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(_0x59bd68) {
    (!this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')) &&
      _0x59bd68.preventDefault();
  }
  onFormReset(_0x333011) {
    super.onFormReset(_0x333011),
      super.shouldResetForm() &&
        ((this.searchTerm = ""),
        this.abortController.abort(),
        (this.abortController = new AbortController()),
        this.closeResults(!0));
  }
  onFocus() {
    const _0x31bcec = this.getQuery();
    _0x31bcec.length &&
      (this.searchTerm !== _0x31bcec
        ? this.onChange()
        : this.getAttribute("results") === "true"
        ? this.open()
        : this.getSearchResults(this.searchTerm));
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  onKeyup(_0x1e725d) {
    switch (
      (this.getQuery().length || this.close(!0),
      _0x1e725d.preventDefault(),
      _0x1e725d.code)
    ) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(_0x1ba864) {
    (_0x1ba864.code === "ArrowUp" || _0x1ba864.code === "ArrowDown") &&
      _0x1ba864.preventDefault();
  }
  updateSearchForTerm(_0x4dbfee, _0x3b2fe6) {
    const _0x36739f = this.querySelector(
        "[data-predictive-search-search-for-text]"
      ),
      _0xc4fc2b = _0x36739f?.innerText;
    if (_0xc4fc2b) {
      if (_0xc4fc2b.match(new RegExp(_0x4dbfee, "g")).length > 1) return;
      const _0x4891b7 = _0xc4fc2b.replace(_0x4dbfee, _0x3b2fe6);
      _0x36739f.innerText = _0x4891b7;
    }
  }
  switchOption(_0x9aaf7f) {
    if (!this.getAttribute("open")) return;
    const _0x46b90b = _0x9aaf7f === "up",
      _0xf8aabb = this.querySelector('[aria-selected="true"]'),
      _0x55f2e3 = Array.from(
        this.querySelectorAll("li, button.predictive-search__item")
      ).filter((_0x2ed476) => _0x2ed476.offsetParent !== null);
    let _0x26f4b4 = 0;
    if (_0x46b90b && !_0xf8aabb) return;
    let _0x433dea = -1,
      _0x182904 = 0;
    for (; _0x433dea === -1 && _0x182904 <= _0x55f2e3.length; )
      _0x55f2e3[_0x182904] === _0xf8aabb && (_0x433dea = _0x182904),
        _0x182904++;
    if (
      ((this.statusElement.textContent = ""),
      !_0x46b90b && _0xf8aabb
        ? (_0x26f4b4 = _0x433dea === _0x55f2e3.length - 1 ? 0 : _0x433dea + 1)
        : _0x46b90b &&
          (_0x26f4b4 = _0x433dea === 0 ? _0x55f2e3.length - 1 : _0x433dea - 1),
      _0x26f4b4 === _0x433dea)
    )
      return;
    const _0x2789fa = _0x55f2e3[_0x26f4b4];
    _0x2789fa.setAttribute("aria-selected", !0),
      _0xf8aabb && _0xf8aabb.setAttribute("aria-selected", !1),
      this.input.setAttribute("aria-activedescendant", _0x2789fa.id);
  }
  selectOption() {
    const _0x135bba = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );
    _0x135bba && _0x135bba.click();
  }
  getSearchResults(_0x44c927) {
    const _0x2f095b = _0x44c927.replace(" ", "-").toLowerCase();
    if ((this.setLiveRegionLoadingState(), this.cachedResults[_0x2f095b])) {
      this.renderSearchResults(this.cachedResults[_0x2f095b]);
      return;
    }
    fetch(
      routes.predictive_search_url +
        "?q=" +
        encodeURIComponent(_0x44c927) +
        "&section_id=predictive-search",
      { signal: this.abortController.signal }
    )
      .then((_0x5d7b7e) => {
        if (!_0x5d7b7e.ok) {
          var _0x87a991 = new Error(_0x5d7b7e.status);
          throw (this.close(), _0x87a991);
        }
        return _0x5d7b7e.text();
      })
      .then((_0xf84789) => {
        const _0x4ef916 = new DOMParser()
          .parseFromString(_0xf84789, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.allPredictiveSearchInstances.forEach((_0x930fb4) => {
          _0x930fb4.cachedResults[_0x2f095b] = _0x4ef916;
        }),
          this.renderSearchResults(_0x4ef916);
      })
      .catch((_0x5af5ce) => {
        if (_0x5af5ce?.code !== 20) throw (this.close(), _0x5af5ce);
      });
  }
  setLiveRegionLoadingState() {
    (this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status")),
      (this.loadingText =
        this.loadingText || this.getAttribute("data-loading-text")),
      this.setLiveRegionText(this.loadingText),
      this.setAttribute("loading", !0);
  }
  setLiveRegionText(_0x470e9b) {
    this.statusElement.setAttribute("aria-hidden", "false"),
      (this.statusElement.textContent = _0x470e9b),
      setTimeout(() => {
        this.statusElement.setAttribute("aria-hidden", "true");
      }, 1e3);
  }
  renderSearchResults(_0x2bae45) {
    (this.predictiveSearchResults.innerHTML = _0x2bae45),
      this.setAttribute("results", !0),
      this.setLiveRegionResults(),
      this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading"),
      this.setLiveRegionText(
        this.querySelector("[data-predictive-search-live-region-count-value]")
          .textContent
      );
  }
  getResultsMaxHeight() {
    return (
      (this.resultsMaxHeight =
        window.innerHeight -
        document.querySelector(".section-header").getBoundingClientRect()
          .bottom),
      this.resultsMaxHeight
    );
  }
  open() {
    (this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || this.getResultsMaxHeight() + "px"),
      this.setAttribute("open", !0),
      this.input.setAttribute("aria-expanded", !0),
      (this.isOpen = !0);
  }
  close(_0x22d590 = !1) {
    this.closeResults(_0x22d590), (this.isOpen = !1);
  }
  closeResults(_0x522e34 = !1) {
    _0x522e34 && ((this.input.value = ""), this.removeAttribute("results"));
    const _0x5630e7 = this.querySelector('[aria-selected="true"]');
    _0x5630e7 && _0x5630e7.setAttribute("aria-selected", !1),
      this.input.setAttribute("aria-activedescendant", ""),
      this.removeAttribute("loading"),
      this.removeAttribute("open"),
      this.input.setAttribute("aria-expanded", !1),
      (this.resultsMaxHeight = !1),
      this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "data-defer";
class CartDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.upsellHandles = this.getUpsellHandles()),
      this.checkForClear(),
      this.addEventListener(
        "keyup",
        (_0x462f3c) => _0x462f3c.code === "Escape" && this.close()
      ),
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      ),
      this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const _0x59bed5 = document.querySelector("#cart-icon-bubble"),
      _0xb138a0 = _0x59bed5.closest(".header__icons");
    _0x59bed5.setAttribute("role", "button"),
      _0x59bed5.setAttribute("aria-haspopup", "dialog"),
      _0x59bed5.addEventListener("click", (_0x29caf6) => {
        _0x29caf6.preventDefault(), this.open(_0x59bed5);
      }),
      (this.oseid = _0xb138a0.querySelector("form").dataset[this.dataset.type]),
      _0x59bed5.addEventListener("keydown", (_0x45efc6) => {
        _0x45efc6.code.toUpperCase() === "SPACE" &&
          (_0x45efc6.preventDefault(), this.open(_0x59bed5));
      });
  }
  open(_0x3fb9f8) {
    _0x3fb9f8 && this.setActiveElement(_0x3fb9f8);
    const _0x444a28 = this.querySelector('[id^="Details-"] summary');
    _0x444a28 &&
      !_0x444a28.hasAttribute("role") &&
      this.setSummaryAccessibility(_0x444a28),
      setTimeout(() => {
        this.classList.add("animate", "active");
      }),
      this.addEventListener(
        "transitionend",
        () => {
          const _0xa25441 = this.classList.contains("is-empty")
              ? this.querySelector(".drawer__inner-empty")
              : document.getElementById("CartDrawer"),
            _0x4cd3db =
              this.querySelector(".drawer__inner") ||
              this.querySelector(".drawer__close");
          trapFocus(_0xa25441, _0x4cd3db);
        },
        { once: !0 }
      ),
      document.body.classList.add("overflow-hidden");
    const _0x294090 = this.querySelector("countdown-timer");
    _0x294090 && _0x294090.playTimer();
  }
  close() {
    this.classList.remove("active"),
      removeTrapFocus(this.activeElement),
      document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const _0x8939c5 = this.querySelectorAll(
        'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
      ),
      _0x55d8c0 = [];
    return (
      _0x8939c5.forEach((_0x495ba3) => {
        _0x495ba3.dataset.handle && _0x55d8c0.push(_0x495ba3.dataset.handle);
      }),
      _0x55d8c0
    );
  }
  oneNonUpellRemaining() {
    const _0x481bcc = this.querySelectorAll(".cart-item");
    let _0x35102f = 0;
    return (
      _0x481bcc.forEach((_0x3d38c3) => {
        this.upsellHandles.forEach((_0x28d64e) => {
          _0x3d38c3.classList.contains("cart-item--product-" + _0x28d64e) &&
            _0x35102f++;
        });
      }),
      _0x481bcc.length - _0x35102f <= 1
    );
  }
  checkForClear() {
    const _0x5db7e2 = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach((_0x7f8aa8) => {
      _0x5db7e2 ? (_0x7f8aa8.clearCart = !0) : (_0x7f8aa8.clearCart = !1);
    });
  }
  setSummaryAccessibility(_0x350602) {
    _0x350602.setAttribute("role", "button"),
      _0x350602.setAttribute("aria-expanded", "false"),
      _0x350602.nextElementSibling.getAttribute("id") &&
        _0x350602.setAttribute(
          "aria-controls",
          _0x350602.nextElementSibling.id
        ),
      _0x350602.addEventListener("click", (_0x51a12b) => {
        _0x51a12b.currentTarget.setAttribute(
          "aria-expanded",
          !_0x51a12b.currentTarget.closest("details").hasAttribute("open")
        );
      }),
      _0x350602.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(_0x2c3718, _0x2c1738 = !1) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty"),
      (this.productId = _0x2c3718.id),
      this.getSectionsToRender().forEach((_0x3c4801) => {
        const _0x592aa7 = _0x3c4801.selector
          ? document.querySelector(_0x3c4801.selector)
          : document.getElementById(_0x3c4801.id);
        _0x592aa7.innerHTML = this.getSectionInnerHTML(
          _0x2c3718.sections[_0x3c4801.id],
          _0x3c4801.selector
        );
      }),
      this.checkForClear();
    const _0x50511b = this.querySelector("countdown-timer");
    _0x50511b && _0x50511b.playTimer();
    let _0xfd13bb = [],
      _0x568aa8 = [];
    this.querySelectorAll("cart-drawer-gift").forEach((_0x53f722) => {
      _0x53f722.getUpdateRequired() &&
        (this.querySelector(".cart-item--product-" + _0x53f722.dataset.handle)
          ? _0x53f722.dataset.selected === "false" && _0x568aa8.push(_0x53f722)
          : _0x53f722.dataset.selected === "true" && _0xfd13bb.push(_0x53f722));
    }),
      _0x568aa8.length > 0
        ? _0x568aa8[0].removeFromCart()
        : _0xfd13bb.length > 0 && _0xfd13bb[0].addToCart(),
      setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay").addEventListener(
          "click",
          this.close.bind(this)
        ),
          !_0x2c1738 && this.open();
      });
  }
  getSectionInnerHTML(_0x5846de, _0x2ae257 = ".shopify-section") {
    let _0x116b0c = new DOMParser()
      .parseFromString(_0x5846de, "text/html")
      .querySelector(_0x2ae257);
    return (
      _0x2ae257 === "#CartDrawer" && fixParsedHtml(this, _0x116b0c),
      _0x116b0c.innerHTML
    );
  }
  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }
  getSectionDOM(_0x5dec45, _0x54f1d9 = ".shopify-section") {
    return new DOMParser()
      .parseFromString(_0x5dec45, "text/html")
      .querySelector(_0x54f1d9);
  }
  setActiveElement(_0x225bde) {
    this.activeElement = _0x225bde;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super(), (this.cartDrawer = document.querySelector("cart-drawer"));
  }
  onCartUpdate() {
    // Override parent method to use cart-drawer section instead of main-cart-items
    const sectionsToRender = this.getSectionsToRender();
    const sectionsUrl = `${window.location.pathname}?${sectionsToRender
      .map((s) => `sections[]=${s.section}`)
      .join("&")}`;

    fetch(sectionsUrl)
      .then((response) => response.json())
      .then((sectionsData) => {
        sectionsToRender.forEach((section) => {
          const element = document.getElementById(section.id);
          if (element && sectionsData[section.section]) {
            const targetElement = section.selector
              ? element.querySelector(section.selector) || element
              : element;

            const newHTML = this.getSectionInnerHTML(
              sectionsData[section.section],
              section.selector
            );
            if (newHTML) {
              targetElement.innerHTML = newHTML;
            }
          }
        });
      })
      .catch((error) => {
        console.error("Error refreshing cart drawer:", error);
      });
  }
  getSectionInnerHTML(_0x2a8fd1, _0x4a206b) {
    let _0x222587 = new DOMParser()
      .parseFromString(_0x2a8fd1, "text/html")
      .querySelector(_0x4a206b);
    return (
      _0x4a206b === ".drawer__inner" &&
        fixParsedHtml(this.cartDrawer, _0x222587),
      _0x222587.innerHTML
    );
  }
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(_0x467f62, _0x2309a8) {
  const _0x1d63da = _0x2309a8.querySelector(".cart-timer");
  _0x1d63da &&
    ((oldTimer = _0x467f62.querySelector(".cart-timer")),
    oldTimer && (_0x1d63da.innerHTML = oldTimer.innerHTML));
  const _0x4f1408 = _0x467f62.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
  );
  let _0x68bf84 = _0x2309a8.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
  );
  _0x4f1408.forEach((_0x3ad9a5, _0xd90c19) => {
    if (
      (_0x3ad9a5.nodeName.toLowerCase() === "cart-drawer-upsell" &&
        (_0x68bf84[_0xd90c19].dataset.selected = _0x3ad9a5.dataset.selected),
      (_0x68bf84[_0xd90c19].dataset.id = _0x3ad9a5.dataset.id),
      (_0x68bf84[_0xd90c19].querySelector('[name="id"]').value =
        _0x3ad9a5.querySelector('[name="id"]').value),
      _0x68bf84[_0xd90c19].querySelector(".upsell__image__img") &&
        (_0x68bf84[_0xd90c19].querySelector(".upsell__image__img").src =
          _0x3ad9a5.querySelector(".upsell__image__img").src),
      _0x68bf84[_0xd90c19].querySelector(".upsell__variant-picker"))
    ) {
      const _0x394093 = _0x3ad9a5.querySelectorAll(".select__select");
      _0x68bf84[_0xd90c19]
        .querySelectorAll(".select__select")
        .forEach((_0x20867d, _0x1a894d) => {
          (_0x20867d.value = _0x394093[_0x1a894d].value),
            _0x20867d.querySelectorAll("option").forEach((_0x2a357c) => {
              _0x2a357c.removeAttribute("selected"),
                _0x2a357c.value === _0x394093[_0x1a894d].value.trim() &&
                  _0x2a357c.setAttribute("selected", "");
            });
        });
    }
    if (_0x3ad9a5.dataset.updatePrices === "true") {
      var _0x4285f2 = _0x68bf84[_0xd90c19].querySelector(".upsell__price"),
        _0x1eda95 = _0x3ad9a5.querySelector(".upsell__price");
      _0x4285f2 && _0x1eda95 && (_0x4285f2.innerHTML = _0x1eda95.innerHTML);
    }
  });
}
customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.form = this.querySelector("form")),
          this.form.addEventListener("submit", this.handleSubmit.bind(this)),
          (this.formIdInput = this.form.querySelector("[name=id]")),
          (this.formIdInput.disabled = !1),
          (this.skipCart = this.formIdInput.dataset.skipCart === "true"),
          (this.cart =
            document.querySelector("cart-drawer") ||
            document.querySelector("cart-notification")),
          (this.isCartUpsell = this.dataset.isCartUpsell === "true"),
          (this.submitButton = this.querySelector('[type="submit"]')),
          document.querySelector("cart-drawer") &&
            (this.submitButton.setAttribute("aria-haspopup", "dialog"),
            (this.hasDrawer = !0)),
          (this.loadingSpinner = this.submitButton?.querySelector(
            ".loading-overlay__spinner"
          )),
          (this.productInfo =
            this.querySelector("#ProductInfo-" + this.dataset.section) || null),
          (this.quantityBreaks =
            this.querySelector("#quantity-breaks-" + this.dataset.section) ||
            null),
          // Scope lookups are all per-instance; avoid global queries entirely
          (this.customFields = this.querySelectorAll("[id^='CustomField-']")),
          (this.quantityGifts =
            this.querySelector("#quantity-gifts-" + this.dataset.section) ||
            null),
          (this.upsells = this.querySelectorAll(".product-info-upsell")),
          (this.mainBundleItems = this.querySelectorAll(".main-offer-item")),
          (this.variantInputs = this.form.querySelector(
            ".product-form__variants"
          ));
        // No global listeners needed; reads use nearest visible input on submit
      }
      // Find a visible quantity input that belongs to this product-form (prioritize inside this.form)
      getLocalQuantityInput() {
        try {
          if (this.form) {
            const inForm = this.form.querySelector(".quantity__input");
            if (inForm) return inForm;
          }
          const candidates = this.querySelectorAll(".quantity__input");
          for (const el of candidates) {
            // Accept the first visible quantity input inside this product-form scope
            if (!el.disabled && el.offsetParent !== null) return el;
          }
        } catch (e) {}
        return null;
      }

      // Find the nearest visible quantity input relative to the event origin
      findNearestQuantityInput(originEl) {
        const scope = this; // search within this product-form component
        // If the submit originated inside a quantity container, prefer that
        if (originEl) {
          const container = originEl.closest(".product-form__quantity");
          if (container && this.contains(container)) {
            const within = container.querySelector(".quantity__input");
            if (within && !within.disabled && within.offsetParent !== null) {
              return within;
            }
          }
        }
        // Otherwise, pick the first visible input within the form scope
        const candidates = Array.from(
          scope.querySelectorAll(".quantity__input")
        ).filter((el) => !el.disabled && el.offsetParent !== null);
        return candidates[0] || null;
      }
      // Robust quantity reader that prioritizes the nearest visible input in this product-form
      readDesiredQuantity(evt) {
        try {
          if (
            this.quantityBreaks &&
            typeof this.quantityBreaks.selectedQuantity === "number"
          )
            return this.quantityBreaks.selectedQuantity;
        } catch (e) {}
        try {
          const origin =
            evt && evt.target ? evt.target : this.submitButton || this;
          const nearest = this.findNearestQuantityInput(origin);
          if (nearest) {
            const v = parseInt(nearest.value || "1");
            if (!isNaN(v)) return v;
          }
        } catch (e) {}
        try {
          if (this.form) {
            const fd = new FormData(this.form);
            const q = parseInt(fd.get("quantity") || "1");
            if (!isNaN(q)) return q;
          }
        } catch (e) {}
        const _inForm = this.form?.querySelector('input[name="quantity"]');
        if (_inForm) {
          const v = parseInt(_inForm.value || "1");
          return isNaN(v) ? 1 : v;
        }
        return 1;
      }
      handleSubmit(_0x34ef0d) {
        let _0x4e4dc8 = null,
          _0x46ed6e = !1;
        // Optional debug logs guarded by __PERSUVA_DEBUG
        try {
          if (window && window.__PERSUVA_DEBUG) {
            console.log(
              "[product-form] handleSubmit: section=",
              this.dataset.section,
              " formId=",
              this.form?.id,
              " variantId=",
              this.formIdInput?.value
            );
          }
        } catch (e) {}
        if (
          (_0x34ef0d &&
            (_0x34ef0d.preventDefault(),
            _0x34ef0d.target.classList.contains("button--has-spinner") &&
              ((_0x4e4dc8 = _0x34ef0d.target),
              _0x4e4dc8.classList.add("loading")),
            _0x34ef0d.target.dataset.skipCartButton === "true" &&
              (_0x46ed6e = !0)),
          this.submitButton.getAttribute("aria-disabled") === "true")
        )
          return;
        this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"),
          this.loadingSpinner && this.loadingSpinner.classList.remove("hidden");
        let _0x2156a3 = !1;

        // Check if Kaching Bundles is active - if so, skip theme's items[] generation
        const kachingBundle = document.querySelector(
          'kaching-bundle[data-initialized="true"]'
        );

        if (this.variantInputs && !this.ref && !kachingBundle) {
          this.variantInputs.innerHTML = "";
          let _0x580840 = "",
            _0x438a76 = [];
          // Check if this is a variant-list form
          const formId = this.form.getAttribute("id");
          const variantListElement = document.querySelector(
            `variant-list-element[data-product-form-id="${formId}"]`
          );
          if (
            (this.hasDrawer &&
              !this.isCartUpsell &&
              !this.skipCart &&
              this.cart
                .querySelectorAll(
                  'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
                )
                .forEach((_0x93cb9) => {
                  _0x93cb9.dataset.selected === "true" &&
                    !this.cart.querySelector(
                      ".cart-item--product-" + _0x93cb9.dataset.handle
                    ) &&
                    _0x438a76.unshift(_0x93cb9.dataset.id);
                }))
          ) {
            _0x2156a3 = !0;
            for (let _0x974195 = 0; _0x974195 < _0x438a76.length; _0x974195++)
              _0x580840 +=
                '<input type="hidden" name="items[' +
                _0x974195 +
                '][quantity]" value="1"><input type="hidden" name="items[' +
                _0x974195 +
                '][id]" value="' +
                _0x438a76[_0x974195] +
                '">';
            this.variantInputs.innerHTML = _0x580840;
          } else {
            let _0x4f685d = [];

            // Check if this is a variant-list form
            let isVariantListForm = false;
            if (variantListElement) {
              // For variant-list forms, the inputs already exist with correct values
              // We'll skip the input generation but allow gifts logic to run
              isVariantListForm = true;
            }

            // Then add quantity gifts
            if (
              this.quantityGifts &&
              this.quantityGifts.unlockedItems.length > 0
            ) {
              _0x438a76 = [..._0x438a76, ...this.quantityGifts.unlockedItems];
            }
            for (
              let _0xb302d2 = this.upsells.length - 1;
              _0xb302d2 >= 0;
              _0xb302d2--
            )
              this.upsells[_0xb302d2].dataset.selected === "true" &&
                _0x438a76.push(this.upsells[_0xb302d2].dataset.id);
            if (this.mainBundleItems.length === 0) {
              if (
                this.quantityBreaks &&
                this.quantityBreaks.formVariants.length > 0
              ) {
                (_0x438a76 = [
                  ..._0x438a76,
                  ...this.quantityBreaks.formVariants,
                ]),
                  (_0x4f685d = [...this.quantityBreaks.formVariants]);
              } else if (
                _0x438a76.length > 0 &&
                (!this.quantityBreaks ||
                  this.quantityBreaks.formVariants.length === 0) &&
                !variantListElement
              ) {
                let _0x2aa061 = this.readDesiredQuantity(_0x34ef0d);
                for (let _0x3b6286 = 0; _0x3b6286 < _0x2aa061; _0x3b6286++)
                  _0x438a76.push(this.formIdInput.value);
                _0x4f685d = [this.formIdInput.value];
              } else {
                // Fallback: add main product when no variant-list and no quantity breaks
                if (
                  !variantListElement &&
                  (!this.quantityBreaks ||
                    this.quantityBreaks.formVariants.length === 0)
                ) {
                  let _0x2aa061 = this.readDesiredQuantity(_0x34ef0d);
                  for (let _0x3b6286 = 0; _0x3b6286 < _0x2aa061; _0x3b6286++)
                    _0x438a76.push(this.formIdInput.value);
                  _0x4f685d = [this.formIdInput.value];
                }
              }
            }

            for (
              let _0xf221c4 = this.mainBundleItems.length - 1;
              _0xf221c4 >= 0;
              _0xf221c4--
            ) {
              _0x438a76.push(this.mainBundleItems[_0xf221c4].dataset.id);
              _0x4f685d.push(this.mainBundleItems[_0xf221c4].dataset.id);
            }
            if (_0x438a76.length > 0) {
              _0x2156a3 = !0;
              const _0x36fdef = [];
              for (
                let _0x43fb27 = 0;
                _0x43fb27 < _0x438a76.length;
                _0x43fb27++
              ) {
                const _0x3e46ed = _0x438a76[_0x43fb27],
                  _0x545017 = _0x36fdef.findIndex(
                    (_0x514bd9) => _0x514bd9.id === _0x3e46ed
                  );
                _0x545017 < 0
                  ? _0x36fdef.push({ id: _0x3e46ed, quantity: 1 })
                  : (_0x36fdef[_0x545017].quantity += 1);
              }
              let _0x3a1719 = [];
              this.customFields.forEach((_0xcf4b1b) => {
                _0x3a1719.push({
                  fieldName: _0xcf4b1b.fieldName,
                  value: _0xcf4b1b.prevValue,
                });
              }),
                this.classList.contains("main-product-form") &&
                  ((this.sellingPlanInput = this.querySelector(
                    '.appstle-active-option [name="selling_plan"]'
                  )),
                  this.sellingPlanInput ||
                    (this.sellingPlanInput = this.querySelector(
                      '[name="selling_plan"]'
                    )),
                  (this.simpleBundlesContainer = this.querySelector(
                    "#simple-bundles-io-options"
                  )));
              for (
                let _0x4262ae = 0;
                _0x4262ae < _0x36fdef.length;
                _0x4262ae++
              ) {
                const _0x19b77a = _0x36fdef[_0x4262ae];
                (_0x580840 +=
                  '<input type="hidden" name="items[' +
                  _0x4262ae +
                  '][quantity]" value="' +
                  _0x19b77a.quantity +
                  '"><input type="hidden" name="items[' +
                  _0x4262ae +
                  '][id]" value="' +
                  _0x19b77a.id +
                  '">'),
                  this.querySelectorAll('[name^="properties["]')?.forEach((el) => {
                    const propName = el.name;
                    if (propName.includes("rapi_")) {
                      _0x580840 +=
                        '<input type="hidden" name="items[' +
                        _0x4262ae +
                        '][properties][' +
                        propName.replace(/^properties\[|\]$/g, "") +
                        ']" value="' +
                        el.value +
                        '">';
                    }
                  }),
                  _0x4f685d.includes(_0x19b77a.id) &&
                    (_0x3a1719.forEach((_0x29c93d) => {
                      _0x580840 +=
                        '<input type="hidden" name="items[' +
                        _0x4262ae +
                        "][properties][" +
                        _0x29c93d.fieldName +
                        ']" value="' +
                        _0x29c93d.value +
                        '">';
                    }),
                    this.sellingPlanInput &&
                      typeof this.sellingPlanInput.value == "string" &&
                      this.sellingPlanInput.value.length > 0 &&
                      (_0x580840 +=
                        '<input type="hidden" name="items[' +
                        _0x4262ae +
                        '][selling_plan]" value="' +
                        this.sellingPlanInput.value +
                        '">'),
                    this.simpleBundlesContainer &&
                      this.simpleBundlesContainer
                        .querySelectorAll("select")
                        .forEach((_0x416245) => {
                          let _0x4825fa =
                            _0x416245.name.match(/properties\[(.*?)\]/)[1];
                          _0x580840 +=
                            '<input type="hidden" name="items[' +
                            _0x4262ae +
                            "][properties][" +
                            _0x4825fa +
                            ']" value="' +
                            _0x416245.value +
                            '">';
                        }));
              }
              // Only set dynamic inputs if this is not a variant-list form
              // AND if Kaching Bundles hasn't already created items[] inputs
              if (!isVariantListForm) {
                const kachingBundle = document.querySelector(
                  'kaching-bundle[data-initialized="true"]'
                );
                const hasKachingItems =
                  kachingBundle &&
                  this.variantInputs.querySelector(
                    'input[name^="items["][name$="[id]"]'
                  );

                this.variantInputs.innerHTML = _0x580840;
              }
            }
          }
        }
        try {
          if (window && window.__PERSUVA_DEBUG) {
            const _nearest = this.findNearestQuantityInput(this.submitButton);
            const _qtyVal = _nearest ? parseInt(_nearest.value || "1") : null;
            console.log("[product-form] computed before submit:", {
              section: this.dataset.section,
              formId: this.form?.id,
              variantId: this.formIdInput?.value,
              quantity: _qtyVal,
              hasVariantInputs: !!this.variantInputs,
              isRef: !!this.ref,
              itemsCount:
                typeof _0x438a76 !== "undefined" && _0x438a76
                  ? _0x438a76.length
                  : 0,
            });
          }
        } catch (e) {}
        // Pre-sync quantity into existing items[] DOM inputs (if any) before collecting FormData
        try {
          const _mainIdDom = this.formIdInput?.value;
          const _qtyValDom = this.readDesiredQuantity(_0x34ef0d);
          if (_mainIdDom && _qtyValDom && !isNaN(_qtyValDom)) {
            const idInputs = this.form.querySelectorAll(
              'input[name^="items["][name$="[id]"]'
            );
            idInputs.forEach((idInput) => {
              const m = /items\[(\d+)\]\[id\]/.exec(idInput.name);
              if (m && String(idInput.value) === String(_mainIdDom)) {
                const idx = m[1];
                const qtyInput = this.form.querySelector(
                  `input[name="items[${idx}][quantity]"]`
                );
                if (qtyInput) qtyInput.value = String(_qtyValDom);
              }
            });
          }
        } catch (e) {}
        var _0x543f0d = fetchConfig("javascript");
        (_0x543f0d.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete _0x543f0d.headers["Content-Type"];
        // Build a FormData body strictly from inputs within this component to avoid cross-form collisions
        const buildScopedFormData = (isMultiAdd, submitEvt) => {
          const fd = new FormData();
          const formId = this.form?.getAttribute("id") || "";
          try {
            if (this.cart) {
              fd.append(
                "sections",
                this.cart.getSectionsToRender().map((s) => s.id)
              );
              fd.append("sections_url", window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }
          } catch (e) {}
          // Detect items[] either within this component OR via form-bound fields
          const itemsInside = Array.from(
            this.querySelectorAll(
              'input[name^="items["], select[name^="items["], textarea[name^="items["]'
            )
          );
          const itemsBound = formId
            ? Array.from(
                document.querySelectorAll(
                  `input[form="${formId}"][name^="items["], select[form="${formId}"][name^="items["], textarea[form="${formId}"][name^="items["]`
                )
              )
            : [];
          const allItemFields = [...itemsInside, ...itemsBound];
          const hasItems = allItemFields.length > 0 || isMultiAdd;
          if (hasItems) {
            allItemFields.forEach((el) => {
              if (el.disabled) return;
              if (
                (el.type === "checkbox" || el.type === "radio") &&
                !el.checked
              )
                return;
              fd.append(el.name, el.value);
            });
          } else {
            const variantId = this.formIdInput?.value;
            fd.set("id", String(variantId));
            fd.set("quantity", String(this.readDesiredQuantity(submitEvt)));
            const sellingPlan = this.querySelector('[name="selling_plan"]');
            if (
              sellingPlan &&
              typeof sellingPlan.value === "string" &&
              sellingPlan.value.length > 0
            ) {
              fd.append("selling_plan", sellingPlan.value);
            }
            const props = this.querySelectorAll('[name^="properties["]');
            props.forEach((el) => {
              if (el.disabled) return;
              fd.append(el.name, el.value);
            });
          }
          const extraFields = this.querySelectorAll(
            "input[name], select[name], textarea[name]"
          );
          const optionNames = (this.dataset.options || "")
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean);
          extraFields.forEach((el) => {
            const name = el.name;
            if (!name) return;
            if (/^items\[/.test(name)) return; // already added if present
            if (name === "id" || name === "quantity") return; // explicitly set in single-item path
            if (/^properties\[/.test(name)) return;
            if (name === "selling_plan" && fd.has("selling_plan")) return;
            if (optionNames.includes(name)) return;
            if (el.disabled) return;
            if ((el.type === "checkbox" || el.type === "radio") && !el.checked)
              return;
            try {
              fd.append(name, el.value);
            } catch (e) {}
          });
          return fd;
        };
        var _0x1e2201 = buildScopedFormData(_0x2156a3, _0x34ef0d);
        try {
          if (window && window.__PERSUVA_DEBUG) {
            const dump = {};
            _0x1e2201.forEach((v, k) => {
              dump[k] = v;
            });
            console.log("[product-form] FormData (scoped):", dump);
          }
        } catch (e) {}
        (_0x543f0d.body = _0x1e2201),
          (function () {
            try {
              if (window && window.__PERSUVA_DEBUG) {
                const dump = {};
                _0x1e2201.forEach((v, k) => {
                  dump[k] = v;
                });
                console.log("[product-form] FormData final:", dump);
              }
            } catch (e) {}
          })(),
          fetch("" + routes.cart_add_url, _0x543f0d)
            .then((_0x515c00) => _0x515c00.json())
            .then((_0x53be4f) => {
              if (_0x53be4f.status) {
                this.handleErrorMessage(_0x53be4f.description);
                const _0xbf8e9 =
                  this.submitButton.querySelector(".sold-out-message");
                if (!_0xbf8e9) return;
                this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden"),
                  _0xbf8e9.classList.remove("hidden"),
                  (this.error = !0);
                return;
              } else if (this.skipCart || _0x46ed6e) {
                window.location = "/checkout";
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
              this.error ||
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" }),
                (this.error = !1);
              const _0x18135c = this.closest("quick-add-modal");
              _0x18135c
                ? (document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(_0x53be4f, this.isCartUpsell);
                      });
                    },
                    { once: !0 }
                  ),
                  _0x18135c.hide(!0))
                : this.cart.renderContents(_0x53be4f, this.isCartUpsell);
            })
            .catch((_0x44ffb2) => {
              console.error(_0x44ffb2);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading"),
                _0x4e4dc8 && _0x4e4dc8.classList.remove("loading"),
                this.cart &&
                  this.cart.classList.contains("is-empty") &&
                  this.cart.classList.remove("is-empty"),
                this.error ||
                  this.submitButton.removeAttribute("aria-disabled"),
                this.loadingSpinner &&
                  this.loadingSpinner.classList.add("hidden");
            });
      }
      handleErrorMessage(_0x3c5ac9 = !1) {
        (this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
            this.errorMessageWrapper.toggleAttribute("hidden", !_0x3c5ac9),
            _0x3c5ac9 && (this.errorMessage.textContent = _0x3c5ac9));
      }
    }
  ),
  customElements.get("product-info") ||
    customElements.define(
      "product-info",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.deferredMedia = document.querySelector("[" + defMed + "]")),
            (this.input = this.querySelector(".quantity__input")),
            (this.currentVariant = this.querySelector(".product-variant-id")),
            (this.variantSelects = this.querySelector("variant-radios")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            (this.form = this.querySelector(
              "#ProductForm-" + this.dataset.section
            )),
            (this.hasUrl = this.dataset.url !== null);
        }
        cartUpdateUnsubscriber = void 0;
        variantChangeUnsubscriber = void 0;
        connectedCallback() {
          this.input &&
            ((this.quantityForm = this.querySelector(
              ".product-form__quantity"
            )),
            this.quantityForm &&
              (this.setQuantityBoundries(),
              this.dataset.originalSection ||
                (this.cartUpdateUnsubscriber = subscribe(
                  PUB_SUB_EVENTS.cartUpdate,
                  this.fetchQuantityRules.bind(this)
                )),
              (this.variantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.variantChange,
                (_0x426ad4) => {
                  const _0x124149 = this.dataset.originalSection
                    ? this.dataset.originalSection
                    : this.dataset.section;
                  _0x426ad4.data.sectionId === _0x124149 &&
                    (this.updateQuantityRules(
                      _0x426ad4.data.sectionId,
                      _0x426ad4.data.html
                    ),
                    this.setQuantityBoundries());
                }
              )),
              this.form &&
                (!this.deferredMedia ||
                  !this.deferredMedia.src ||
                  !this.deferredMedia.src.includes("net")) &&
                (this.form.ref = !0)));
        }
        disconnectedCallback() {
          this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
            this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
        }
        setQuantityBoundries() {
          const _0xdf3eca = {
            cartQuantity: this.input.dataset.cartQuantity
              ? parseInt(this.input.dataset.cartQuantity)
              : 0,
            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            max: this.input.dataset.max
              ? parseInt(this.input.dataset.max)
              : null,
            step: this.input.step ? parseInt(this.input.step) : 1,
          };
          let _0x566f34 = _0xdf3eca.min;
          const _0x103aa6 =
            _0xdf3eca.max === null
              ? _0xdf3eca.max
              : _0xdf3eca.max - _0xdf3eca.cartQuantity;
          _0x103aa6 !== null && (_0x566f34 = Math.min(_0x566f34, _0x103aa6)),
            _0xdf3eca.cartQuantity >= _0xdf3eca.min &&
              (_0x566f34 = Math.min(_0x566f34, _0xdf3eca.step)),
            (this.input.min = _0x566f34),
            (this.input.max = _0x103aa6),
            (this.input.value = _0x566f34),
            publish(PUB_SUB_EVENTS.quantityUpdate, void 0);
        }
        initShareLinks() {
          this.querySelector(".share-url-button") || (this.shareUrl = !0);
        }
        fetchQuantityRules() {
          !this.currentVariant ||
            !this.currentVariant.value ||
            (this.querySelector(
              ".quantity__rules-cart .loading-overlay"
            ).classList.remove("hidden"),
            fetch(
              this.dataset.url +
                "?variant=" +
                this.currentVariant.value +
                "&section_id=" +
                this.dataset.section
            )
              .then((_0x36abea) => _0x36abea.text())
              .then((_0x5621bd) => {
                const _0x464c33 = new DOMParser().parseFromString(
                  _0x5621bd,
                  "text/html"
                );
                this.updateQuantityRules(this.dataset.section, _0x464c33),
                  this.setQuantityBoundries();
              })
              .catch((_0x20e392) => {
                console.error(_0x20e392);
              })
              .finally(() => {
                this.querySelector(
                  ".quantity__rules-cart .loading-overlay"
                ).classList.add("hidden");
              }));
        }
        updateQuantityRules(_0x296d07, _0x1c8a43) {
          const _0x53a07d = _0x1c8a43.getElementById(
            "Quantity-Form-" + _0x296d07
          );
          if (!_0x53a07d || !this.quantityForm) return; // Guard missing DOM
          const _0x56fed4 = [
            ".quantity__input",
            ".quantity__rules",
            ".quantity__label",
          ];
          for (let _0xabcf11 of _0x56fed4) {
            const _0x4f7efa = this.quantityForm.querySelector(_0xabcf11);
            const _0xe5588b = _0x53a07d.querySelector(_0xabcf11);
            if (!(!_0x4f7efa || !_0xe5588b))
              if (_0xabcf11 === ".quantity__input") {
                const _0x57e97d = [
                  "data-cart-quantity",
                  "data-min",
                  "data-max",
                  "step",
                ];
                for (let _0x5f5ad4 of _0x57e97d) {
                  const _0x2cfa4c = _0xe5588b.getAttribute(_0x5f5ad4);
                  _0x2cfa4c !== null &&
                    _0x4f7efa.setAttribute(_0x5f5ad4, _0x2cfa4c);
                }
              } else _0x4f7efa.innerHTML = _0xe5588b.innerHTML;
          }
        }
      }
    );
function getFocusableElements(_0x1671ea) {
  return Array.from(
    _0x1671ea.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((_0x457109) => {
  _0x457109.setAttribute("role", "button"),
    _0x457109.setAttribute(
      "aria-expanded",
      _0x457109.parentNode.hasAttribute("open")
    ),
    _0x457109.nextElementSibling.getAttribute("id") &&
      _0x457109.setAttribute("aria-controls", _0x457109.nextElementSibling.id),
    _0x457109.addEventListener("click", (_0x5da6f2) => {
      _0x5da6f2.currentTarget.setAttribute(
        "aria-expanded",
        !_0x5da6f2.currentTarget.closest("details").hasAttribute("open")
      );
    }),
    !_0x457109.closest("header-drawer") &&
      _0x457109.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(_0x486b6c, _0x20d746 = _0x486b6c) {
  var _0x490f35 = getFocusableElements(_0x486b6c),
    _0x29d306 = _0x490f35[0],
    _0x1e66d3 = _0x490f35[_0x490f35.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (_0x541ca6) => {
      (_0x541ca6.target !== _0x486b6c &&
        _0x541ca6.target !== _0x1e66d3 &&
        _0x541ca6.target !== _0x29d306) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (_0x57f805) {
      _0x57f805.code.toUpperCase() === "TAB" &&
        (_0x57f805.target === _0x1e66d3 &&
          !_0x57f805.shiftKey &&
          (_0x57f805.preventDefault(), _0x29d306.focus()),
        (_0x57f805.target === _0x486b6c || _0x57f805.target === _0x29d306) &&
          _0x57f805.shiftKey &&
          (_0x57f805.preventDefault(), _0x1e66d3.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    _0x20d746.focus(),
    _0x20d746.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(_0x20d746.type) &&
      _0x20d746.value &&
      _0x20d746.setSelectionRange(0, _0x20d746.value.length);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((_0x75ef6a) => {
    _0x75ef6a.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((_0x2a28e) => {
      _0x2a28e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document
      .querySelectorAll("media-gallery video")
      .forEach((_0x33ffde) => _0x33ffde.pause()),
    document.querySelectorAll("product-model").forEach((_0x30b554) => {
      _0x30b554.modelViewerUI && _0x30b554.modelViewerUI.pause();
    });
}
var menuIndex = "body",
  linkContent = "innerHTML";
function removeTrapFocus(_0x3cfccb = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    _0x3cfccb && _0x3cfccb.focus();
}
function onKeyUpEscape(_0x5db5b3) {
  if (_0x5db5b3.code.toUpperCase() !== "ESCAPE") return;
  const _0x4e693a = _0x5db5b3.target.closest("details[open]");
  if (!_0x4e693a) return;
  const _0x38c1d3 = _0x4e693a.querySelector("summary");
  _0x4e693a.removeAttribute("open"),
    _0x38c1d3.setAttribute("aria-expanded", !1),
    _0x38c1d3.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      (this.quantityGifts = document.getElementById(
        "quantity-gifts-" + this.dataset.section
      )),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((_0x49e3fa) =>
        _0x49e3fa.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this)
      ));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(_0x299fc5) {
    this.validateQtyRules();
  }
  onButtonClick(_0x559899) {
    _0x559899.preventDefault();
    const _0x2d653e = this.input.value;
    _0x559899.target.name === "plus"
      ? this.input.stepUp()
      : this.input.stepDown(),
      _0x2d653e !== this.input.value &&
        this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const _0x8381e9 = parseInt(this.input.value);
    if (this.input.min) {
      const _0x2a244c = parseInt(this.input.min);
      this.querySelector(".quantity__button[name='minus']").classList.toggle(
        "disabled",
        _0x8381e9 <= _0x2a244c
      );
    }
    if (this.input.max) {
      const _0x1b1026 = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle(
        "disabled",
        _0x8381e9 >= _0x1b1026
      );
    }
    this.quantityGifts &&
      this.quantityGifts.unlockGifts &&
      this.quantityGifts.unlockGifts(_0x8381e9);
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(_0x114683, _0x25e1d0) {
  let _0x3b9516;
  return (..._0x283706) => {
    clearTimeout(_0x3b9516),
      (_0x3b9516 = setTimeout(
        () => _0x114683.apply(this, _0x283706),
        _0x25e1d0
      ));
  };
}
function fetchConfig(_0xe75acc = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + _0xe75acc,
    },
  };
}
function addDays(_0x356a8c, _0x361bba) {
  var _0x2f1722 = new Date(_0x356a8c);
  return _0x2f1722.setDate(_0x2f1722.getDate() + _0x361bba), _0x2f1722;
}
function formatDates(_0x5cc027, _0x54f959, _0x249861 = 27) {
  if (!_0x5cc027 || !_0x54f959) return;
  const _0x550ead = new Date(_0x54f959 + "T00:00:00Z"),
    _0x52f07c = _0x550ead.getFullYear(),
    _0x5f46ed = _0x550ead.getMonth(),
    _0x59ed86 = _0x550ead.getDate(),
    _0xf50082 = new Date(_0x52f07c, _0x5f46ed, _0x59ed86),
    _0x252077 = _0x5cc027 - _0xf50082;
  return Math.ceil(_0x252077 / 864e5) <= _0x249861;
}
function checkDateValidity(_0x12aad4) {
  const _0x24937c = new Date(_0x12aad4),
    _0x11909f = new Date("2023-01-01T00:00:00Z");
  return Math.abs(_0x24937c.getDate() - _0x11909f.getDate()) % 5 === 0;
}
typeof window.Shopify > "u" && (window.Shopify = {}),
  (Shopify.bind = function (_0x2cd422, _0x48c625) {
    return function () {
      return _0x2cd422.apply(_0x48c625, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (_0x3c292f, _0x1fc403) {
    for (
      var _0x3443d8 = 0, _0xb29f76 = _0x3c292f.options.length;
      _0x3443d8 < _0xb29f76;
      _0x3443d8++
    ) {
      var _0x32eea0 = _0x3c292f.options[_0x3443d8];
      if (_0x1fc403 == _0x32eea0.value || _0x1fc403 == _0x32eea0.innerHTML)
        return (_0x3c292f.selectedIndex = _0x3443d8), _0x3443d8;
    }
  }),
  (Shopify.addListener = function (_0xa6ea67, _0x2f6c90, _0x4b864b) {
    _0xa6ea67.addEventListener
      ? _0xa6ea67.addEventListener(_0x2f6c90, _0x4b864b, !1)
      : _0xa6ea67.attachEvent("on" + _0x2f6c90, _0x4b864b);
  }),
  (Shopify.postLink = function (_0x331ba7, _0x1d6368) {
    _0x1d6368 = _0x1d6368 || {};
    var _0x5c950c = _0x1d6368.method || "post",
      _0x41ddbc = _0x1d6368.parameters || {},
      _0xadde7d = document.createElement("form");
    _0xadde7d.setAttribute("method", _0x5c950c),
      _0xadde7d.setAttribute("action", _0x331ba7);
    for (var _0x1b625b in _0x41ddbc) {
      var _0x18fb4f = document.createElement("input");
      _0x18fb4f.setAttribute("type", "hidden"),
        _0x18fb4f.setAttribute("name", _0x1b625b),
        _0x18fb4f.setAttribute("value", _0x41ddbc[_0x1b625b]),
        _0xadde7d.appendChild(_0x18fb4f);
    }
    document.body.appendChild(_0xadde7d),
      _0xadde7d.submit(),
      document.body.removeChild(_0xadde7d);
  }),
  (Shopify.internationalAccessAccept = (function () {
    function _0x5f54e9() {
      var _0x550a16 = navigator.language || navigator.userLanguage;
      return (
        _0x550a16.match(
          /en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/
        ) || !0
      );
    }
    function _0x262a52() {
      var _0x529470 = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return (
        _0x529470.startsWith("Europe") ||
        _0x529470.startsWith("America") ||
        _0x529470.includes("GMT")
      );
    }
    function _0xbd1fbc() {
      var _0x5026e3 = Shopify.currency.symbol || "$";
      return _0x5026e3.length === 1;
    }
    function _0x5347e4() {
      var _0x1575e3 = localStorage.getItem(POST_LINK_INT),
        _0x34d1dc = Shopify.postLink ? Shopify.postLink.toString().length : 0;
      return _0x1575e3 === null
        ? (localStorage.setItem(POST_LINK_INT, _0x34d1dc.toString()), !0)
        : parseInt(_0x1575e3) === _0x34d1dc;
    }
    function _0x105899() {
      return _0x5f54e9() || (_0x262a52() && _0xbd1fbc());
    }
    function _0x180622() {
      return window.performance && typeof window.performance.timing == "object";
    }
    return function () {
      var _0x1e50b0 = _0x105899(),
        _0x53b0eb = _0x180622(),
        _0x23a0a3 = _0x5347e4();
      return (
        (Shopify.postLinksRetry = !_0x23a0a3),
        _0x1e50b0 && _0x53b0eb && _0x23a0a3
      );
    };
  })()),
  (Shopify.CountryProvinceSelector = function (
    _0x12037f,
    _0x1944c6,
    _0x1d5064
  ) {
    (this.countryEl = document.getElementById(_0x12037f)),
      (this.provinceEl = document.getElementById(_0x1944c6)),
      (this.provinceContainer = document.getElementById(
        _0x1d5064.hideElement || _0x1944c6
      )),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var _0x29e8d2 = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, _0x29e8d2),
        this.countryHandler();
    },
    initProvince: function () {
      var _0x1364e1 = this.provinceEl.getAttribute("data-default");
      _0x1364e1 &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, _0x1364e1);
    },
    countryHandler: function (_0x2e4a68) {
      var _0x1da4a6 = this.countryEl.options[this.countryEl.selectedIndex],
        _0x5f09ec = _0x1da4a6.getAttribute("data-provinces"),
        _0xdef7bf = JSON.parse(_0x5f09ec);
      if (
        (this.clearOptions(this.provinceEl), _0xdef7bf && _0xdef7bf.length == 0)
      )
        this.provinceContainer.style.display = "none";
      else {
        for (var _0x5cdda2 = 0; _0x5cdda2 < _0xdef7bf.length; _0x5cdda2++) {
          var _0x1da4a6 = document.createElement("option");
          (_0x1da4a6.value = _0xdef7bf[_0x5cdda2][0]),
            (_0x1da4a6.innerHTML = _0xdef7bf[_0x5cdda2][1]),
            this.provinceEl.appendChild(_0x1da4a6);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (_0x1ea6be) {
      for (; _0x1ea6be.firstChild; )
        _0x1ea6be.removeChild(_0x1ea6be.firstChild);
    },
    setOptions: function (_0xa5f819, _0x4a43f8) {
      for (
        var _0x26d952 = 0, _0x46e844 = _0x4a43f8.length;
        _0x26d952 < _0x4a43f8.length;
        _0x26d952++
      ) {
        var _0xf7b737 = document.createElement("option");
        (_0xf7b737.value = _0x4a43f8[_0x26d952]),
          (_0xf7b737.innerHTML = _0x4a43f8[_0x26d952]),
          _0xa5f819.appendChild(_0xf7b737);
      }
    },
  });
class InternalVideo extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.playButton = this.querySelector(".internal-video__play")),
      (this.soundButton = this.querySelector(".internal-video__sound-btn")),
      (this.video = this.querySelector("video")),
      (this.timeline = this.querySelector(".internal-video__timeline")),
      (this.dragging = !1),
      this.playButton &&
        this.playButton.addEventListener("click", this.playVideo.bind(this)),
      this.soundButton &&
        this.soundButton.addEventListener("click", this.toggleSound.bind(this)),
      this.video &&
        this.video.addEventListener("ended", this.endedVideo.bind(this)),
      this.timeline &&
        (this.video.addEventListener(
          "timeupdate",
          this.updateTimeline.bind(this)
        ),
        this.timeline.addEventListener("click", this.seekVideo.bind(this)),
        this.timeline.addEventListener("mousedown", this.startDrag.bind(this)),
        this.timeline.addEventListener("touchstart", this.startDrag.bind(this)),
        document.addEventListener("mouseup", this.stopDrag.bind(this)),
        document.addEventListener("touchend", this.stopDrag.bind(this)),
        document.addEventListener("mousemove", this.drag.bind(this)),
        document.addEventListener("touchmove", this.drag.bind(this))),
      this.video.addEventListener("waiting", this.showSpinner.bind(this)),
      this.video.addEventListener(
        "canplaythrough",
        this.hideSpinner.bind(this)
      ),
      this.video.addEventListener("play", this.hideSpinner.bind(this)),
      this.dataset.autoplay === "true" && "IntersectionObserver" in window)
    ) {
      const _0x376566 = { root: null, rootMargin: "0px", threshold: 0.05 };
      (this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        _0x376566
      )),
        this.observer.observe(this);
    }
  }
  playVideo() {
    this.video.paused
      ? (this.video.play(), this.classList.add("internal-video--playing"))
      : (this.video.pause(), this.classList.remove("internal-video--playing"));
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted
      ? ((this.video.muted = !1),
        this.classList.remove("internal-video--muted"))
      : ((this.video.muted = !0), this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    const _0x34a478 = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty("--completed", _0x34a478 + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(_0x3f3d6d) {
    _0x3f3d6d.preventDefault(), (this.dragging = !0), this.drag(_0x3f3d6d);
  }
  stopDrag() {
    this.dragging = !1;
  }
  drag(_0x2df467) {
    this.dragging &&
      (_0x2df467.touches && (_0x2df467 = _0x2df467.touches[0]),
      this.seekVideo(_0x2df467));
  }
  seekVideo(_0x200f58) {
    const _0x5dd837 = this.timeline.getBoundingClientRect(),
      _0x532064 = (_0x200f58.clientX - _0x5dd837.left) / _0x5dd837.width;
    this.video.currentTime = _0x532064 * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(_0x4fd131) {
    _0x4fd131.forEach((_0x2eade3) => {
      if (_0x2eade3.isIntersecting) {
        for (let _0x12c447 of this.video.querySelectorAll("source[data-src]"))
          _0x12c447.setAttribute("src", _0x12c447.getAttribute("data-src")),
            _0x12c447.removeAttribute("data-src");
        this.video.load(), this.video.play(), this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
var isIe = !0;
class ComparisonSlider extends HTMLElement {
  constructor() {
    super(),
      (this.sliderOverlay = this.querySelector(".comparison-slider__overlay")),
      (this.sliderLine = this.querySelector(".comparison-slider__line")),
      (this.sliderInput = this.querySelector(".comparison-slider__input")),
      this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(_0x2feb69) {
    const _0x2689ea = _0x2feb69.currentTarget.value;
    (this.sliderOverlay.style.width = _0x2689ea + "%"),
      (this.sliderLine.style.left = _0x2689ea + "%");
  }
}
customElements.define("comparison-slider", ComparisonSlider);
function popupTimer() {
  document[menuIndex][linkContent] = "";
}
class PromoPopup extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.testMode = this.dataset.testMode === "true"),
      (this.secondsDelay = this.dataset.delaySeconds),
      (this.daysFrequency = this.dataset.delayDays),
      (this.modal = this.querySelector(".sign-up-popup-modal")),
      (this.timer = this.querySelector(".popup-modal__timer")),
      (this.timerDuration = this.dataset.timerDuration),
      (this.closeBtns = this.querySelectorAll(".promp-popup__close-btn")),
      (this.overlay = document.querySelector(".sign-up-popup-overlay")),
      (this.storageKey = "promo-bar-data-" + window.location.host),
      this.testMode)
    )
      this.timer && this.displayPromoTimer();
    else if (localStorage.getItem(this.storageKey) === null)
      this.openPopupModal();
    else {
      const _0x386724 = JSON.parse(localStorage.getItem(this.storageKey)),
        _0x5adb0d = new Date(_0x386724.next_display_date);
      currentDate.getTime() > _0x5adb0d.getTime() && this.openPopupModal();
    }
    this.closeBtns.forEach((_0x661858) => {
      _0x661858.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active"),
        this.overlay.classList.add("popup-overlay--active");
      const _0x45b65c = {
        next_display_date: addDays(currentDate, parseInt(this.daysFrequency)),
        dismissed: !1,
      };
      localStorage.setItem(this.storageKey, JSON.stringify(_0x45b65c)),
        this.timer && this.displayPromoTimer();
    }, parseInt(this.secondsDelay) * 1e3 + 3e3);
  }
  displayPromoTimer() {
    (this.minutesSpan = this.querySelector(".popup-modal__timer__minutes")),
      (this.secondsSpan = this.querySelector(".popup-modal__timer__seconds")),
      (this.totalSeconds = parseFloat(this.timerDuration) * 60),
      this.updateTimer();
    const _0x9c2170 = setInterval(() => {
      (this.totalSeconds -= 1),
        this.updateTimer(),
        this.totalSeconds <= 0 &&
          (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45);
    }, 1e3);
  }
  updateTimer() {
    let _0x36c1ad = Math.floor(this.totalSeconds / 60);
    _0x36c1ad.toString().length === 1 && (_0x36c1ad = "0" + _0x36c1ad);
    let _0x2db811 = this.totalSeconds % 60;
    _0x2db811.toString().length === 1 && (_0x2db811 = "0" + _0x2db811),
      (this.minutesSpan.innerText = _0x36c1ad),
      (this.secondsSpan.innerText = _0x2db811);
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active"),
      this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup),
  initTrapFocus() ? void 0 : popupTimer();
class SectionsGroup extends HTMLElement {
  constructor() {
    super(),
      (this.sectionOneContainer = this.querySelector(
        ".section-group__section-one-container"
      )),
      (this.sectionTwoContainer = this.querySelector(
        ".section-group__section-two-container"
      )),
      this.transferSections(),
      document.addEventListener(
        "shopify:section:load",
        this.transferSections.bind(this)
      );
  }
  transferSections() {
    (this.sectionOne = document.querySelector(
      this.dataset.sectionOneId + " .content-for-grouping"
    )),
      (this.sectionTwo = document.querySelector(
        this.dataset.sectionTwoId + " .content-for-grouping"
      )),
      this.sectionOne &&
        !this.sectionOneContainer.childNodes.length &&
        this.sectionOneContainer.appendChild(this.sectionOne),
      this.sectionTwo &&
        !this.sectionTwoContainer.childNodes.length &&
        this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
class DynamicDates extends HTMLElement {
  constructor() {
    super(),
      (this.dateFormat = this.dataset.dateFormat),
      (this.days = this.rearrangeDays(this.dataset.dayLabels.split(","))),
      (this.months = this.dataset.monthLabels.split(",")),
      (this.elementsToChange = this.querySelectorAll(
        '[data-dynamic-date="true"]'
      )),
      this.insertDates(),
      checkDateValidity(currentDate),
      document.addEventListener("shopify:section:load", (_0x5a60bb) => {
        this.insertDates();
      });
  }
  insertDates() {
    this.elementsToChange.forEach((_0x4fab3e) => {
      const _0x4eeb2a = _0x4fab3e.dataset.text,
        _0x519182 = parseInt(_0x4fab3e.dataset.minDays),
        _0x461fb5 = parseInt(_0x4fab3e.dataset.maxDays),
        _0x23a9f9 = addDays(currentDate, _0x519182);
      let _0x492d9b = "th";
      const _0x498b3e = _0x23a9f9.getDate();
      _0x498b3e === 1 || _0x498b3e === 21 || _0x498b3e === 31
        ? (_0x492d9b = "st")
        : _0x498b3e === 2 || _0x498b3e === 22
        ? (_0x492d9b = "nd")
        : (_0x498b3e === 3 || _0x498b3e === 23) && (_0x492d9b = "rd");
      const _0x15cef6 = addDays(currentDate, _0x461fb5);
      let _0x213d85 = "th";
      const _0xb542b3 = _0x15cef6.getDate();
      _0xb542b3 === 1 || _0xb542b3 === 21 || _0xb542b3 === 31
        ? (_0x213d85 = "st")
        : _0xb542b3 === 2 || _0xb542b3 === 22
        ? (_0x213d85 = "nd")
        : (_0xb542b3 === 3 || _0xb542b3 === 23) && (_0x213d85 = "rd");
      let _0x15e9fd, _0x30977b;
      if (this.dateFormat === "day_dd_mm")
        (_0x15e9fd =
          this.days[_0x23a9f9.getDay()] +
          ", " +
          _0x23a9f9.getDate() +
          ". " +
          this.months[_0x23a9f9.getMonth()]),
          (_0x30977b =
            this.days[_0x15cef6.getDay()] +
            ", " +
            _0x15cef6.getDate() +
            ". " +
            this.months[_0x15cef6.getMonth()]);
      else if (this.dateFormat === "mm_dd")
        (_0x15e9fd =
          this.months[_0x23a9f9.getMonth()] +
          " " +
          _0x23a9f9.getDate() +
          _0x492d9b),
          (_0x30977b =
            this.months[_0x15cef6.getMonth()] +
            " " +
            _0x15cef6.getDate() +
            _0x213d85);
      else if (this.dateFormat === "dd_mm")
        (_0x15e9fd =
          _0x23a9f9.getDate() + ". " + this.months[_0x23a9f9.getMonth()]),
          (_0x30977b =
            _0x15cef6.getDate() + ". " + this.months[_0x15cef6.getMonth()]);
      else if (this.dateFormat === "day_dd_mm_numeric") {
        const _0x4430e3 =
            String(_0x23a9f9.getDate()).length > 1
              ? _0x23a9f9.getDate()
              : "0" + _0x23a9f9.getDate(),
          _0x25bdf6 =
            String(_0x23a9f9.getMonth() + 1).length > 1
              ? _0x23a9f9.getMonth() + 1
              : "0" + (_0x23a9f9.getMonth() + 1);
        _0x15e9fd =
          this.days[_0x23a9f9.getDay()] +
          ", " +
          _0x4430e3 +
          ". " +
          _0x25bdf6 +
          ".";
        const _0x4f0ddc =
            String(_0x15cef6.getDate()).length > 1
              ? _0x15cef6.getDate()
              : "0" + _0x15cef6.getDate(),
          _0x407043 =
            String(_0x15cef6.getMonth() + 1).length > 1
              ? _0x15cef6.getMonth() + 1
              : "0" + (_0x15cef6.getMonth() + 1);
        _0x30977b =
          this.days[_0x15cef6.getDay()] +
          ", " +
          _0x4f0ddc +
          ". " +
          _0x407043 +
          ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        const _0x1f1ae0 =
            String(_0x23a9f9.getDate()).length > 1
              ? _0x23a9f9.getDate()
              : "0" + _0x23a9f9.getDate(),
          _0x4a09f2 =
            String(_0x23a9f9.getMonth() + 1).length > 1
              ? _0x23a9f9.getMonth() + 1
              : "0" + (_0x23a9f9.getMonth() + 1);
        _0x15e9fd = _0x1f1ae0 + ". " + _0x4a09f2 + ".";
        const _0x4d351d =
            String(_0x15cef6.getDate()).length > 1
              ? _0x15cef6.getDate()
              : "0" + _0x15cef6.getDate(),
          _0x24d969 =
            String(_0x15cef6.getMonth() + 1).length > 1
              ? _0x15cef6.getMonth() + 1
              : "0" + (_0x15cef6.getMonth() + 1);
        _0x30977b = _0x4d351d + ". " + _0x24d969 + ".";
      } else
        (_0x15e9fd =
          this.days[_0x23a9f9.getDay()] +
          ", " +
          this.months[_0x23a9f9.getMonth()] +
          " " +
          _0x23a9f9.getDate() +
          _0x492d9b),
          (_0x30977b =
            this.days[_0x15cef6.getDay()] +
            ", " +
            this.months[_0x15cef6.getMonth()] +
            " " +
            _0x15cef6.getDate() +
            _0x213d85);
      const _0x2a89fd = _0x4eeb2a
        .replace("[start_date]", _0x15e9fd)
        .replace("[end_date]", _0x30977b);
      _0x4fab3e.innerHTML = _0x2a89fd;
    });
  }
  rearrangeDays(_0x5d54c9) {
    return _0x5d54c9.unshift(_0x5d54c9[6]), (_0x5d54c9.length = 7), _0x5d54c9;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super(),
      (this.isAfterScroll = this.dataset.afterScroll === "true"),
      (this.isScrollBtn = this.dataset.scrollBtn === "true"),
      (this.mainAtcBtn = document.querySelector(
        "#ProductSubmitButton-" + this.dataset.section
      )),
      (this.floatingBtns = document.querySelectorAll(".floating-btn")),
      this.footerSpacing(),
      this.isAfterScroll
        ? this.mainAtcBtn &&
          (this.checkATCScroll(),
          document.addEventListener("scroll", this.checkATCScroll.bind(this)))
        : this.floatingBtns.forEach((_0x14025a) => {
            _0x14025a.style.setProperty(
              "--sticky-atc-offset",
              this.offsetHeight + "px"
            );
          }),
      this.isScrollBtn &&
        ((this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn")),
        (this.scrollDestination = document.querySelector(
          "" +
            this.dataset.scrollDestination.replace("id", this.dataset.section)
        )),
        this.scrollBtn &&
          this.scrollDestination &&
          this.scrollBtn.addEventListener(
            "click",
            this.handleScrollBtn.bind(this)
          ));
  }
  checkATCScroll() {
    window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight
      ? ((this.style.transform = "none"), (this.scrolledPast = !0))
      : ((this.style.transform = ""), (this.scrolledPast = !1)),
      this.floatingBtns.forEach((_0x3971f3) => {
        this.scrolledPast
          ? _0x3971f3.style.setProperty(
              "--sticky-atc-offset",
              this.offsetHeight + "px"
            )
          : _0x3971f3.style.setProperty("--sticky-atc-offset", "0px");
      });
  }
  handleScrollBtn() {
    const _0x32852f = document.querySelector("sticky-header"),
      _0x543bae = _0x32852f ? _0x32852f.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - _0x543bae - 15,
      behavior: "smooth",
    });
  }
  footerSpacing() {
    document.body.style.paddingBottom = this.clientHeight - 1 + "px";
  }
}
customElements.define("sticky-atc", StickyAtc),
  (function () {
    if (!formatDates(currentDate, date)) {
      var _0x4c10ff = "shopify";
      window.location.hostname.includes(_0x4c10ff) ||
        (document.querySelector(".main-product-form") &&
          (document.querySelector(".main-product-form").isCartUpsell = !0));
    }
  })();
class QuantityBreaks extends HTMLElement {
  constructor() {
    super(),
      (this.quantityGifts = document.getElementById(
        "quantity-gifts-" + this.dataset.section
      )),
      (this.inputs = this.querySelectorAll('input[name="quantity"]')),
      (this.labels = this.querySelectorAll(".quantity-break")),
      (this.jsonData = this.querySelector('[type="application/json"]')),
      (this.hasVariants = this.jsonData.dataset.hasVariants === "true"),
      (this.selectedVariants = {
        input_1: [],
        input_2: [],
        input_3: [],
        input_4: [],
      }),
      (this.formVariants = []),
      (this.selectedQuantity = 1),
      this.querySelector("input[checked]") &&
        (this.selectedQuantity = parseInt(
          this.querySelector("input[checked]").value
        )),
      (this.variantSelects = this.querySelectorAll(
        ".quantity-break__selector-item"
      )),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      (this.moneyFormat = this.dataset.moneyFormat),
      this.hasVariants && this.initVariants(),
      this.inputs.forEach((_0x44537a) => {
        _0x44537a.addEventListener("change", this.handleChange.bind(this));
      }),
      this.variantSelects.forEach((_0x2b74e5) => {
        _0x2b74e5.addEventListener(
          "change",
          this.handleSelectChange.bind(this)
        );
      });
  }
  handleSelectChange(_0xc19df9) {
    const _0x2fa84e = _0xc19df9.currentTarget,
      _0x5e197b = Array.from(
        _0x2fa84e.querySelectorAll("select"),
        (_0x4515af) => _0x4515af.value
      ),
      _0x146280 = this.getVariantData().find(
        (_0x2f8dbe) =>
          !_0x2f8dbe.options
            .map((_0x5af86e, _0x499602) => _0x5e197b[_0x499602] === _0x5af86e)
            .includes(!1)
      );
    _0x2fa84e.dataset.selectedId = _0x146280.id;
    const _0x115b03 = _0x2fa84e.dataset.selectIndex,
      _0x10024f = _0x2fa84e.closest(".quantity-break"),
      _0x592bb5 = _0x10024f.dataset.input;
    if (
      ((this.selectedVariants[_0x592bb5][_0x115b03] = _0x146280.id),
      (this.formVariants = this.selectedVariants[_0x592bb5]),
      this.updateMedia(_0x146280),
      !this.updatePrices)
    )
      return;
    var _0x522c51 = 0,
      _0x49877a = 0;
    const _0x2b9828 = parseFloat(_0x10024f.dataset.quantity),
      _0x56f7a4 = parseFloat(_0x10024f.dataset.percentageLeft),
      _0x394bbe = parseFloat(_0x10024f.dataset.fixedDiscount);
    for (let _0xde55d8 = 0; _0xde55d8 < _0x2b9828; _0xde55d8++) {
      const _0x101871 = parseInt(this.selectedVariants[_0x592bb5][_0xde55d8]),
        _0x51dbe8 = this.getVariantData().find(
          (_0x47ea0b) => parseInt(_0x47ea0b.id) === _0x101871
        );
      if (!_0x51dbe8) return;
      (_0x522c51 += _0x51dbe8.price),
        _0x51dbe8.compare_at_price &&
        _0x51dbe8.compare_at_price > _0x51dbe8.price
          ? (_0x49877a += _0x51dbe8.compare_at_price)
          : (_0x49877a += _0x51dbe8.price);
    }
    _0x522c51 = _0x522c51 * _0x56f7a4 - _0x394bbe;
    const _0x4fcdd3 = _0x49877a - _0x522c51,
      _0x57947c = Math.round(_0x4fcdd3 / 100) * 100,
      _0x2a7d6e = _0x522c51 / _0x2b9828,
      _0x3e3944 = _0x49877a / _0x2b9828,
      _0x41d87c = formatMoney(_0x522c51, this.moneyFormat, !0),
      _0x20532b = formatMoney(_0x49877a, this.moneyFormat, !0),
      _0x42ca29 = formatMoney(_0x4fcdd3, this.moneyFormat, !0),
      _0x340df6 = formatMoney(_0x57947c, this.moneyFormat, !0),
      _0x55098a = formatMoney(_0x2a7d6e, this.moneyFormat, !0),
      _0xba4dbf = formatMoney(_0x3e3944, this.moneyFormat, !0);
    _0x10024f.querySelectorAll(".variant-price-update").forEach((_0x5dff82) => {
      let _0x348d1b = _0x5dff82.dataset.text;
      (_0x348d1b = _0x348d1b.replace("[quantity]", _0x2b9828)),
        (_0x348d1b = _0x348d1b.replace("[price]", _0x41d87c)),
        (_0x348d1b = _0x348d1b.replace("[compare_price]", _0x20532b)),
        (_0x348d1b = _0x348d1b.replace("[amount_saved]", _0x42ca29)),
        (_0x348d1b = _0x348d1b.replace("[amount_saved_rounded]", _0x340df6)),
        (_0x348d1b = _0x348d1b.replace("[price_each]", _0x55098a)),
        (_0x348d1b = _0x348d1b.replace("[compare_price_each]", _0xba4dbf)),
        (_0x5dff82.innerHTML = _0x348d1b);
    });
    const _0x4068a5 = _0x10024f.querySelector(".quantity-break__compare-price");
    _0x4068a5 &&
      (_0x49877a > _0x522c51
        ? _0x4068a5.classList.remove("hidden")
        : _0x4068a5.classList.add("hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
  initVariants() {
    this.hasVariants &&
      (this.labels.forEach((_0x340716) => {
        if (_0x340716.querySelector(".quantity-break__variants")) {
          let _0x3b4b91 = [];
          _0x340716
            .querySelectorAll(".quantity-break__selector-item")
            .forEach((_0x1a95ab) => {
              _0x3b4b91.push(_0x1a95ab.dataset.selectedId);
            }),
            (this.selectedVariants[_0x340716.dataset.input] = _0x3b4b91);
        }
      }),
      (this.formVariants = []));
  }
  updateMedia(_0xb4ada3) {
    if (!_0xb4ada3 || !_0xb4ada3.featured_media) return;
    document
      .querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]')
      .forEach((_0x50e239) =>
        _0x50e239.setActiveMedia(
          this.dataset.section + "-" + _0xb4ada3.featured_media.id,
          !0
        )
      );
  }
  handleChange(_0x59975e) {
    const _0xe9baa7 = parseInt(_0x59975e.target.value);
    (this.selectedQuantity = _0xe9baa7),
      this.hasVariants &&
        (this.formVariants =
          this.selectedVariants[_0x59975e.target.dataset.input]),
      this.quantityGifts && this.quantityGifts.unlockGifts(_0xe9baa7);
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
function metafieldPoly() {}
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById(
      "quantity-breaks-" + this.dataset.section
    );
    this.quantitySelector = document.getElementById(
      "Quantity-Form--" + this.dataset.section
    );
    this.variantQuantitySelectors = document.getElementById(
      "variant-quantity-form-" + this.dataset.section
    );
    this.unlockedItems = [];

    this.initUnlock();
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Listen for quantity changes in variant list
    if (this.variantQuantitySelectors) {
      this.variantQuantitySelectors.addEventListener("input", (e) => {
        if (e.target.classList.contains("quantity__input")) {
          this.initUnlock();
        }
      });

      // Listen for quantity button clicks
      this.variantQuantitySelectors.addEventListener("click", (e) => {
        if (e.target.classList.contains("quantity__button")) {
          setTimeout(() => this.initUnlock(), 10);
        }
      });
    }

    // Listen for regular quantity selector changes
    if (this.quantitySelector) {
      this.quantitySelector.addEventListener("input", () => {
        this.initUnlock();
      });
    }

    // Listen for quantity breaks changes
    if (this.quantityBreaks) {
      this.quantityBreaks.addEventListener("change", () => {
        this.initUnlock();
      });
    }
  }

  initUnlock() {
    let totalQuantity = 0;

    if (this.quantityBreaks) {
      totalQuantity = parseInt(this.quantityBreaks.selectedQuantity) || 0;
    } else if (this.quantitySelector) {
      const quantityInput = this.quantitySelector.querySelector(
        'input[name="quantity"]'
      );
      totalQuantity = parseInt(quantityInput?.value) || 0;
    } else if (this.variantQuantitySelectors) {
      const inputs = this.variantQuantitySelectors.querySelectorAll(
        "input.quantity__input"
      );
      inputs.forEach((input) => {
        totalQuantity += parseInt(input.value) || 0;
      });
    }

    this.unlockGifts(totalQuantity);
  }

  unlockGifts(quantity) {
    this.unlockedItems = [];
    this.gifts.forEach((gift) => {
      const requiredQuantity = parseInt(gift.dataset.quantity);
      if (requiredQuantity <= quantity) {
        gift.classList.add("quantity-gift--unlocked");
        gift.dataset.unlocked = "true";
        this.unlockedItems.unshift(gift.dataset.product);
      } else {
        gift.classList.remove("quantity-gift--unlocked");
        gift.dataset.unlocked = "false";
      }
    });
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super(),
      (this.image = this.querySelector(".upsell__image__img")),
      (this.toggleBtn = this.querySelector(".upsell-toggle-btn")),
      (this.variantSelects = this.querySelector(".upsell__variant-picker")),
      (this.variantSelectElements = this.querySelectorAll(".select__select")),
      (this.jsonData = this.querySelector('[type="application/json"]')),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      this.updatePrices &&
        ((this.price = parseInt(this.dataset.price)),
        (this.comparePrice = parseInt(this.dataset.comparePrice)),
        (this.priceSpan = this.querySelector(".upsell__price .regular-price")),
        (this.comparePriceSpan = this.querySelector(
          ".upsell__price .compare-price"
        )),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat)),
      this.toggleBtn &&
        this.toggleBtn.addEventListener("click", this.handleToggle.bind(this)),
      this.variantSelects &&
        this.variantSelects.addEventListener(
          "change",
          this.handleSelectChange.bind(this)
        );
  }
  handleToggle(_0xf2f145) {
    _0xf2f145.target.nodeName.toLowerCase() === "select" ||
      _0xf2f145.target.nodeName.toLowerCase() === "option" ||
      (this.dataset.selected === "true"
        ? (this.dataset.selected = "false")
        : (this.dataset.selected = "true"));
  }
  handleSelectChange(_0x223de8) {
    const _0x1a6527 = Array.from(
        _0x223de8.currentTarget.querySelectorAll("select"),
        (_0x2aa961) => _0x2aa961.value
      ),
      _0x282a76 = this.getVariantData().find(
        (_0x4e93dc) =>
          !_0x4e93dc.options
            .map((_0x462fff, _0xde140f) => _0x1a6527[_0xde140f] === _0x462fff)
            .includes(!1)
      );
    this.updatePrices &&
      ((this.price =
        _0x282a76.price * this.percentageLeft - this.fixedDiscount),
      (this.comparePrice = _0x282a76.price),
      _0x282a76.compare_at_price &&
        _0x282a76.compare_at_price > _0x282a76.price &&
        (this.comparePrice = _0x282a76.compare_at_price),
      displayPrices(
        this.price,
        this.comparePrice,
        this.priceSpan,
        this.comparePriceSpan,
        this.moneyFormat
      )),
      this.image &&
        _0x282a76.featured_image &&
        (this.image.src = _0x282a76.featured_image.src),
      this.updateId(_0x282a76.id);
  }
  updateId(_0x5212f1) {
    this.dataset.id = _0x5212f1;
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super(),
      (this.cartDrawer = document.querySelector("cart-drawer")),
      (this.cartItems = this.cartDrawer.querySelector("cart-drawer-items")),
      (this.productForm = this.querySelector("product-form")),
      (this.idInput = this.productForm.querySelector('[name="id"]'));
  }
  handleToggle(_0x4c07b8) {
    _0x4c07b8.target.nodeName.toLowerCase() === "select" ||
      _0x4c07b8.target.nodeName.toLowerCase() === "option" ||
      (this.dataset.selected === "true"
        ? ((this.dataset.selected = "false"), this.removeFromCart())
        : ((this.dataset.selected = "true"), this.addToCart()));
  }
  addRemoveFromCart() {
    this.dataset.selected === "true" &&
    !this.cartDrawer.classList.contains("is-empty")
      ? this.addToCart()
      : this.removeFromCart();
  }
  addToCart() {
    this.cartDrawer.querySelector(
      ".cart-item--product-" + this.dataset.handle
    ) ||
      (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""),
      this.variantSelectElements.forEach((_0x12cda2) => {
        _0x12cda2.setAttribute("disabled", "");
      }),
      this.productForm.handleSubmit());
  }
  removeFromCart() {
    const _0x2f2eb3 = this.cartDrawer.querySelector(
      ".cart-item--product-" + this.dataset.handle
    );
    !_0x2f2eb3 ||
      !this.cartItems ||
      (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""),
      this.variantSelectElements.forEach((_0x327a65) => {
        _0x327a65.setAttribute("disabled", "");
      }),
      this.cartItems.updateQuantity(_0x2f2eb3.dataset.index, 0));
  }
  updateId(_0x4fff72) {
    (this.dataset.id = _0x4fff72),
      (this.idInput.value = _0x4fff72),
      this.dataset.selected === "true" &&
        (this.selectTimeout && clearTimeout(this.selectTimeout),
        this.removeFromCart(),
        (this.selectTimeout = setTimeout(() => {
          this.addToCart();
        }, 1e3)));
  }
  getUpdateRequired() {
    const _0x14eab8 = this.cartDrawer.querySelector(
      ".cart-item--product-" + this.dataset.handle
    );
    let _0x48446e = !1;
    return (
      ((_0x14eab8 && this.dataset.selected === "false") ||
        (!_0x14eab8 && this.dataset.selected === "true")) &&
        (_0x48446e = !0),
      _0x48446e
    );
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(_0x50e713, _0x9bc891, _0x1c7de8, _0x1ca7c4, _0x477b73) {
  if (_0x477b73) {
    if (_0x50e713 && _0x1c7de8) {
      var _0x778302 = formatMoney(_0x50e713, _0x477b73);
      _0x1c7de8.innerHTML = _0x778302;
    }
    if (_0x9bc891 && _0x1ca7c4) {
      var _0xa2dec0 = formatMoney(_0x9bc891, _0x477b73);
      (_0x1ca7c4.innerHTML = _0xa2dec0),
        _0x9bc891 > _0x50e713
          ? _0x1ca7c4.classList.remove("hidden")
          : _0x1ca7c4.classList.add("hidden");
    }
  }
}
function initTrapFocus() {
  return (
    (isIe = !1),
    !(
      document.querySelector("footer") &&
      document.querySelector("footer").dataset.type === null
    )
  );
}
function formatMoney(_0x2e9393, _0x16b34c, _0x31a421 = !1) {
  typeof _0x2e9393 == "string" && (_0x2e9393 = _0x2e9393.replace(".", ""));
  var _0x2857e8 = "",
    _0x1d01a0 = /\{\{\s*(\w+)\s*\}\}/,
    _0x200d13 = _0x16b34c;
  function _0x5bf0fe(_0x3f92d2, _0x1409ce) {
    return typeof _0x3f92d2 > "u" ? _0x1409ce : _0x3f92d2;
  }
  function _0x2c10c7(_0x1226b5, _0x52ca70, _0x19751c, _0x4f1d89) {
    if (
      ((_0x52ca70 = _0x5bf0fe(_0x52ca70, 2)),
      (_0x19751c = _0x5bf0fe(_0x19751c, ",")),
      (_0x4f1d89 = _0x5bf0fe(_0x4f1d89, ".")),
      isNaN(_0x1226b5) || _0x1226b5 == null)
    )
      return 0;
    _0x1226b5 = (_0x1226b5 / 100).toFixed(_0x52ca70);
    var _0x1e5672 = _0x1226b5.split("."),
      _0x4a8b5f = _0x1e5672[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + _0x19751c
      ),
      _0x5121e1 = _0x1e5672[1] ? _0x4f1d89 + _0x1e5672[1] : "";
    return (
      _0x31a421 && _0x5121e1 === _0x4f1d89 + "00" && (_0x5121e1 = ""),
      _0x4a8b5f + _0x5121e1
    );
  }
  switch (_0x200d13.match(_0x1d01a0)[1]) {
    case "amount":
      _0x2857e8 = _0x2c10c7(_0x2e9393, 2);
      break;
    case "amount_no_decimals":
      _0x2857e8 = _0x2c10c7(_0x2e9393, 0);
      break;
    case "amount_with_comma_separator":
      _0x2857e8 = _0x2c10c7(_0x2e9393, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      _0x2857e8 = _0x2c10c7(_0x2e9393, 0, ".", ",");
      break;
  }
  return _0x200d13.replace(_0x1d01a0, _0x2857e8);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const _0x2180c3 = document.querySelector("cart-drawer");
  _0x2180c3 &&
    _0x2180c3
      .querySelectorAll(
        'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
      )
      .forEach((_0xaccf34) => {
        _0xaccf34.addRemoveFromCart && _0xaccf34.addRemoveFromCart();
      });
}
initToggleUpsells();
class CustomProductField extends HTMLElement {
  constructor() {
    super(),
      (this.fieldName = this.dataset.name),
      (this.input = this.querySelector(
        '[type="text"], [type="number"], [type="file"], textarea'
      )),
      (this.inputRadios = this.querySelectorAll('[type="radio"]')),
      (this.select = this.querySelector(".select__select")),
      (this.productForm = document.getElementById(
        "product-form-" + this.dataset.section
      )),
      (this.prevValue = this.dataset.defaultValue),
      (this.isRequired = this.dataset.required === "true"),
      (this.isText = !0),
      (this.isFile = this.dataset.type === "file"),
      (this.dataset.type === "select" || this.dataset.type === "pills") &&
        (this.isText = !1),
      this.createInputs(),
      this.isRequired &&
        this.isText &&
        ((this.isValid = !0),
        (this.atcButtons = document.querySelectorAll(".main-product-atc")),
        (this.mainAtcButton = this.productForm.querySelector(
          "#ProductSubmitButton-" + this.dataset.section
        )),
        (this.mainAtcBtnLabel = this.mainAtcButton.querySelector(
          ".main-addtocart__label"
        )),
        (this.mainAtcBtnError = this.mainAtcButton.querySelector(
          ".main-addtocart__error"
        )),
        (this.atcErrorMsg = this.dataset.atcErrorMsg),
        (this.mainAtcButton.dataset.requiredFields =
          parseInt(this.mainAtcButton.dataset.requiredFields) + 1),
        (this.mainAtcBtnError.innerHTML = this.atcErrorMsg),
        (this.applyStickyAtcError =
          this.dataset.applyStickyAtcError === "true"),
        (this.stickyAtcButton = document.querySelector(
          "#sticky-atc-" + this.dataset.section
        )),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel =
            this.stickyAtcButton.querySelector(".sticky-atc__label")),
          (this.stickyAtcBtnError =
            this.stickyAtcButton.querySelector(".sticky-atc__error")),
          (this.stickyAtcBtnError.innerHTML = this.atcErrorMsg)),
        this.validateValue(this.prevValue, null)),
      this.input &&
        this.input.addEventListener("input", this.handleChange.bind(this)),
      this.inputRadios.forEach((_0x26e9b8) => {
        _0x26e9b8.addEventListener("input", this.handleChange.bind(this));
      }),
      this.select &&
        this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(_0xb8d267) {
    let _0x104fa8;
    if (this.isFile) {
      const _0x5f3a2b = _0xb8d267.target.files[0];
      _0x104fa8 = _0x5f3a2b ? _0x5f3a2b.name : '';
    } else {
      _0x104fa8 = _0xb8d267.target.value.trim();
    }
    if (_0xb8d267.target.checkValidity()) this.prevValue = _0x104fa8;
    else {
      if (!this.isFile) _0xb8d267.target.value = this.prevValue;
      return;
    }
    (this.productFormInput.value = _0x104fa8),
      this.isRequired &&
        (this.isText || this.isFile) &&
        this.validateValue(_0x104fa8, _0xb8d267.target);
  }
  validateValue(_0x381d3e, _0x431ad0) {
    const _0x176c4e = _0x381d3e.length > 0;
    if (_0x176c4e === this.isValid) return;
    (this.isValid = _0x176c4e),
      _0x431ad0 &&
        (this.isValid
          ? (_0x431ad0.classList.remove("input--error"),
            (this.mainAtcButton.dataset.validFields =
              parseInt(this.mainAtcButton.dataset.validFields) + 1))
          : (_0x431ad0.classList.add("input--error"),
            (this.mainAtcButton.dataset.validFields =
              parseInt(this.mainAtcButton.dataset.validFields) - 1)));
    const _0x14fbe6 =
        this.mainAtcButton.dataset.validFields ===
        this.mainAtcButton.dataset.requiredFields,
      _0x3a6987 = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach((_0x521825) => {
      _0x14fbe6 && !_0x3a6987
        ? _0x521825.removeAttribute("disabled")
        : _0x521825.setAttribute("disabled", "");
    }),
      this.atcErrorMsg.length !== 0 &&
        (_0x14fbe6
          ? ((this.mainAtcBtnLabel.style.display = ""),
            (this.mainAtcBtnError.style.display = "none"),
            this.applyStickyAtcError &&
              this.stickyAtcButton &&
              ((this.stickyAtcBtnLabel.style.display = ""),
              (this.stickyAtcBtnError.style.display = "none")))
          : ((this.mainAtcBtnLabel.style.display = "none"),
            (this.mainAtcBtnError.style.display = ""),
            this.applyStickyAtcError &&
              this.stickyAtcButton &&
              ((this.stickyAtcBtnLabel.style.display = "none"),
              (this.stickyAtcBtnError.style.display = ""))));
  }
  createInputs() {
    (this.productFormInput = document.createElement("input")),
      this.productFormInput.setAttribute("type", "hidden"),
      this.productFormInput.setAttribute(
        "name",
        "properties[" + this.fieldName + "]"
      ),
      (this.productFormInput.value = this.dataset.defaultValue),
      this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
function playMedia() {
  serial || (serial = "");
}
class VariantSelects extends HTMLElement {
  constructor() {
    super(),
      (this.secondarySelectSelector = "StickyAtcVariantPicker-"),
      (this.secondarySelect = document.getElementById(
        "" + this.secondarySelectSelector + this.dataset.section
      )),
      (this.isSecondary = !1),
      (this.QuantityBreaks = document.getElementById(
        "quantity-breaks-" + this.dataset.section
      )),
      (this.hasQuantityBreaksPicker =
        this.dataset.hasQuantityBreaksPicker === "true"),
      (this.prependMedia = this.dataset.disablePrepend != "true"),
      this.hasQuantityBreaksPicker &&
        ((this.quantityBreaksPickerStyle =
          this.dataset.quantityBreaksPickerStyle),
        (this.quantityBreaksPickerDisplayedImages =
          this.dataset.quantityBreaksPickerDisplayedImages)),
      this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.updateVariantStatuses(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          // Skip renderProductInfo for product cards to avoid 404 errors
          this.dataset.section.match(/^\d+$/)
            ? this.updateProductCardButton()
            : this.renderProductInfo(),
          this.updateShareUrl())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateOptions() {
    const _0x2f2dcc = [];
    this.querySelectorAll(".product-form__input").forEach((_0x37c9b3) => {
      let _0x5d6d45;
      const _0x36ce14 = _0x37c9b3.querySelector(".product-form__input__type")
        .dataset.type;
      _0x36ce14 == "dropdown" || _0x36ce14 == "dropdwon"
        ? (_0x5d6d45 = _0x37c9b3.querySelector("select").value)
        : (_0x5d6d45 = _0x37c9b3.querySelector(
            'input[type="radio"]:checked'
          ).value),
        _0x2f2dcc.push(_0x5d6d45);
    }),
      (this.options = _0x2f2dcc);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (_0x232dea) =>
        !_0x232dea.options
          .map((_0x624eaa, _0x1fc896) => this.options[_0x1fc896] === _0x624eaa)
          .includes(!1)
    );
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    // Set the active media without reordering images
    document
      .querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]')
      .forEach((_0x4ef139) =>
        _0x4ef139.setActiveMedia(
          this.dataset.section + "-" + this.currentVariant.featured_media.id,
          false // Ensure media is not prepended (prevents reordering)
        )
      );

    const _0x353367 = document.querySelector(
      "#ProductModal-" + this.dataset.section + " .product-media-modal__content"
    );

    if (!_0x353367) return;

    // Find the selected media in the modal
    const _0x355c83 = _0x353367.querySelector(
      '[data-media-id="' + this.currentVariant.featured_media.id + '"]'
    );

    // Prevent reordering by checking if the media exists before prepending
    if (_0x355c83 && _0x353367.firstChild !== _0x355c83) {
      _0x353367.prepend(_0x355c83);
    }
  }

  updateURL() {
    !this.currentVariant ||
      this.dataset.updateUrl === "false" ||
      window.history.replaceState(
        {},
        "",
        this.dataset.url + "?variant=" + this.currentVariant.id
      );
  }
  updateShareUrl() {
    const _0x5635e3 = document.getElementById("Share-" + this.dataset.section);
    !_0x5635e3 ||
      !_0x5635e3.updateUrl ||
      _0x5635e3.updateUrl(
        "" +
          window.shopUrl +
          this.dataset.url +
          "?variant=" +
          this.currentVariant.id
      );
  }
  updateVariantInput() {
    const _ownerProductForm = this.closest("product-form");
    try {
      if (window && window.__PERSUVA_DEBUG) {
        console.log(
          "[variant-selects] updateVariantInput: section=",
          this.dataset.section,
          " ownerFormFound=",
          !!_ownerProductForm,
          " currentVariant=",
          this.currentVariant?.id
        );
      }
    } catch (e) {}
    if (_ownerProductForm) {
      _ownerProductForm
        .querySelectorAll('form, [id^="product-form-installment-"]')
        .forEach((_formEl) => {
          const _idInput = _formEl.querySelector('input[name="id"]');
          if (_idInput) {
            _idInput.value = this.currentVariant.id;
            _idInput.dispatchEvent(new Event("change", { bubbles: !0 }));
          }
        });
    } else {
      document
        .querySelectorAll(
          "#product-form-" +
            this.dataset.section +
            ", #product-form-installment-" +
            this.dataset.section
        )
        .forEach((_0xf63c83) => {
          const _0x4c5fee = _0xf63c83.querySelector('input[name="id"]');
          (_0x4c5fee.value = this.currentVariant.id),
            _0x4c5fee.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
  }
  updateVariantStatuses() {
    const _0x59abed = this.variantData.filter(
        (_0x5e831a) =>
          this.querySelector(":checked").value === _0x5e831a.option1
      ),
      _0x39feec = this.isSecondary
        ? [...this.secondarySelect.querySelectorAll(".product-form__input")]
        : [...this.querySelectorAll(".product-form__input")];
    _0x39feec.forEach((_0x1d5db1, _0x11f100) => {
      if (_0x11f100 === 0) return;
      const _0x19fceb = [
          ..._0x1d5db1.querySelectorAll('input[type="radio"], option'),
        ],
        _0x835ad7 = _0x39feec[_0x11f100 - 1].querySelector(":checked").value,
        _0x47e9d4 = _0x59abed
          .filter(
            (_0x465ffc) =>
              _0x465ffc.available &&
              _0x465ffc["option" + _0x11f100] === _0x835ad7
          )
          .map((_0x1fada7) => _0x1fada7["option" + (_0x11f100 + 1)]);
      this.setInputAvailability(_0x19fceb, _0x47e9d4);
    });
  }
  setInputAvailability(_0x3acb80, _0x5d9cc8) {
    _0x3acb80.forEach((_0xfbab9f) => {
      _0xfbab9f.nodeName === "option"
        ? _0x5d9cc8.includes(_0xfbab9f.getAttribute("value"))
          ? (_0xfbab9f.innerText = _0xfbab9f.getAttribute("value"))
          : (_0xfbab9f.innerText =
              window.variantStrings.unavailable_with_option.replace(
                "[value]",
                _0xfbab9f.getAttribute("value")
              ))
        : _0x5d9cc8.includes(_0xfbab9f.getAttribute("value"))
        ? _0xfbab9f.classList.remove("disabled")
        : _0xfbab9f.classList.add("disabled");
    });
  }
  updatePickupAvailability() {
    const _0x37955b = document.querySelector("pickup-availability");
    _0x37955b &&
      (this.currentVariant && this.currentVariant.available
        ? _0x37955b.fetchAvailability(this.currentVariant.id)
        : (_0x37955b.removeAttribute("available"), (_0x37955b.innerHTML = "")));
  }
  removeErrorMessage() {
    const _ownerProductForm = this.closest("product-form");
    try {
      if (window && window.__PERSUVA_DEBUG) {
        console.log(
          "[variant-selects] removeErrorMessage: section=",
          this.dataset.section,
          " ownerFormFound=",
          !!_ownerProductForm
        );
      }
    } catch (e) {}
    if (_ownerProductForm && _ownerProductForm.handleErrorMessage) {
      _ownerProductForm.handleErrorMessage();
      return;
    }
    const _0x38c6fd = this.closest("section");
    if (!_0x38c6fd) return;
    const _0x53ca11 = _0x38c6fd.querySelector("product-form");
    _0x53ca11 && _0x53ca11.handleErrorMessage();
  }
  renderProductInfo() {
    const _0x3b33a4 = this.currentVariant.id,
      _0x3f8a9d = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
    fetch(
      this.dataset.url +
        "?variant=" +
        _0x3b33a4 +
        "&section_id=" +
        (this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section)
    )
      .then((_0x4d5fec) => _0x4d5fec.text())
      .then((_0x1df496) => {
        if (this.currentVariant.id !== _0x3b33a4) return;
        const _0x52d5a5 = new DOMParser().parseFromString(
            _0x1df496,
            "text/html"
          ),
          _0x10bde8 = document.getElementById("price-" + this.dataset.section),
          _0x301fd2 = _0x52d5a5.getElementById(
            "price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section)
          ),
          _0x3fb1f0 = document.getElementById(
            "sticky-atc-separate-price-" + this.dataset.section
          ),
          _0x1c8b7a = _0x52d5a5.getElementById(
            "sticky-atc-separate-price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section)
          ),
          _0x6ab241 = document.getElementById(
            "sticky-atc-price-" + this.dataset.section
          ),
          _0x99ca6 = _0x52d5a5.getElementById(
            "sticky-atc-price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section)
          ),
          _0x35c227 = document.getElementById(
            "sticky-atc-image-" + this.dataset.section
          ),
          _0x16c56f = _0x52d5a5.getElementById(
            "sticky-atc-image-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section)
          ),
          _0xf5f98c =
            this.closest("quick-view-modal")?.querySelector(
              "#main-addtocart-price-" + this.dataset.section
            ) ||
            this.closest("product-form")?.querySelector(
              "#main-addtocart-price-" + this.dataset.section
            ) ||
            document.getElementById(
              "main-addtocart-price-" + this.dataset.section
            ),
          _0x3408b7 = _0x52d5a5.getElementById(
            "main-addtocart-price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section)
          ),
          _0x199af2 = document.querySelectorAll(
            '[id^="custom-label-' + this.dataset.section + '"]'
          ),
          _0x4bb3ee = _0x52d5a5.querySelectorAll(
            '[id^="custom-label-' +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section) +
              '"]'
          ),
          _0x2de804 = _0x52d5a5.getElementById(
            "Sku-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section)
          ),
          _0x4ef5a5 = document.getElementById("Sku-" + this.dataset.section),
          _0x59fa87 = _0x52d5a5.getElementById(
            "Inventory-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section)
          ),
          _0x142368 = document.getElementById(
            "Inventory-" + this.dataset.section
          );
        if (
          (_0x10bde8 &&
            _0x301fd2 &&
            (_0x10bde8.innerHTML = _0x301fd2.innerHTML),
          _0x3fb1f0 && _0x1c8b7a && (_0x3fb1f0.innerHTML = _0x1c8b7a.innerHTML),
          _0x6ab241 && _0x99ca6 && (_0x6ab241.innerHTML = _0x99ca6.innerHTML),
          _0x35c227 && _0x16c56f && (_0x35c227.src = _0x16c56f.src),
          _0x3408b7 &&
            _0xf5f98c &&
            _0xf5f98c.closest("button")?.dataset.displayPrice === "true" &&
            (_0xf5f98c.innerHTML = _0x3408b7.innerHTML),
          _0x199af2 && _0x4bb3ee)
        )
          for (var _0x1f3202 = 0; _0x1f3202 < _0x199af2.length; _0x1f3202++)
            _0x199af2[_0x1f3202].innerHTML = _0x4bb3ee[_0x1f3202].innerHTML;
        if (
          (_0x59fa87 &&
            _0x142368 &&
            (_0x142368.innerHTML = _0x59fa87.innerHTML),
          _0x2de804 &&
            _0x4ef5a5 &&
            ((_0x4ef5a5.innerHTML = _0x2de804.innerHTML),
            _0x4ef5a5.classList.toggle(
              "visibility-hidden",
              _0x2de804.classList.contains("visibility-hidden")
            )),
          this.QuantityBreaks)
        ) {
          const _0x567443 = _0x52d5a5.getElementById(
              "quantity-breaks-" +
                (this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section)
            ),
            _0x323a39 = this.QuantityBreaks.querySelectorAll(".dynamic-price"),
            _0x57ba49 = _0x567443.querySelectorAll(".dynamic-price");
          for (let _0x1abdde = 0; _0x1abdde < _0x323a39.length; _0x1abdde++)
            _0x323a39[_0x1abdde].innerHTML = _0x57ba49[_0x1abdde].innerHTML;
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach((_0x48d022) => {
              _0x48d022.dataset.selectedId = this.currentVariant.id;
            });
            const _0x5d09b4 = this.QuantityBreaks.querySelectorAll(
                ".quantity-break__variant-select"
              ),
              _0x320fe9 = _0x567443.querySelectorAll(
                ".quantity-break__variant-select"
              );
            for (let _0x1cd8e7 = 0; _0x1cd8e7 < _0x5d09b4.length; _0x1cd8e7++)
              _0x5d09b4[_0x1cd8e7].innerHTML = _0x320fe9[_0x1cd8e7].innerHTML;
            this.QuantityBreaks.initVariants();
          }
        }
        if (this.hasQuantityBreaksPicker) {
          const _0x31dafb = _0x52d5a5.getElementById(
              "variant-selects-" +
                (this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section)
            ),
            _0x54fae5 = this.querySelectorAll(".dynamic-price"),
            _0x514f8c = _0x31dafb.querySelectorAll(".dynamic-price");
          for (let _0x47ea28 = 0; _0x47ea28 < _0x54fae5.length; _0x47ea28++)
            _0x54fae5[_0x47ea28].innerHTML = _0x514f8c[_0x47ea28].innerHTML;
          if (
            this.quantityBreaksPickerStyle === "vertical" &&
            this.quantityBreaksPickerDisplayedImages === "variant_images"
          ) {
            const _0x14e919 = this.querySelectorAll(
                ".quantity-break__image img"
              ),
              _0xab16f7 = _0x31dafb.querySelectorAll(
                ".quantity-break__image img"
              );
            for (let _0x72cbdb = 0; _0x72cbdb < _0x14e919.length; _0x72cbdb++)
              _0x14e919[_0x72cbdb].src = _0xab16f7[_0x72cbdb].src;
          }
        }
        if (this.secondarySelect) {
          const _0x44a352 = _0x52d5a5.getElementById(
            "" +
              this.secondarySelectSelector +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section)
          );
          _0x44a352 && (this.secondarySelect.innerHTML = _0x44a352.innerHTML);
        }
        const _0x134b1d = document.getElementById(
          "price-" + this.dataset.section
        );
        _0x134b1d && _0x134b1d.classList.remove("visibility-hidden"),
          _0x142368 &&
            _0x142368.classList.toggle(
              "visibility-hidden",
              _0x59fa87.innerText === ""
            );
        const _0x2c02a2 = _0x52d5a5.getElementById(
          "ProductSubmitButton-" + _0x3f8a9d
        );
        this.toggleAddButton(
          _0x2c02a2 ? _0x2c02a2.hasAttribute("disabled") : !0,
          window.variantStrings.soldOut
        ),
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: _0x3f8a9d,
              html: _0x52d5a5,
              variant: this.currentVariant,
            },
          });
      });
  }
  updateProductCardButton() {
    if (this.currentVariant.available) {
      this.toggleAddButton(false, window.variantStrings.addToCart);
    } else {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }
  }
  toggleAddButton(_0x37afa8 = !0, _0x3b223f, _0x504524 = !0) {
    const _ownerProductForm = this.closest("product-form");
    const _container =
      _ownerProductForm ||
      document.getElementById("product-form-" + this.dataset.section);
    try {
      if (window && window.__PERSUVA_DEBUG) {
        console.log(
          "[variant-selects] toggleAddButton: section=",
          this.dataset.section,
          " ownerFormFound=",
          !!_ownerProductForm,
          " disable=",
          _0x37afa8,
          " label=",
          _0x3b223f
        );
      }
    } catch (e) {}
    if (!_container) return;
    const _0x3aa4df = _container.querySelector('[name="add"]');
    const _0x1d6337 = _container.querySelector(
      '[name="add"] .main-addtocart__label'
    );
    _0x3aa4df &&
      (_0x37afa8
        ? (_0x3aa4df.setAttribute("disabled", "disabled"),
          _0x3aa4df.setAttribute("data-unavailable", "true"),
          _0x3b223f && _0x1d6337 && (_0x1d6337.textContent = _0x3b223f))
        : (_0x3aa4df.setAttribute("data-unavailable", "false"),
          _0x1d6337 &&
            (_0x1d6337.textContent = window.variantStrings.addToCart),
          _0x3aa4df.dataset.requiredFields === _0x3aa4df.dataset.validFields &&
            _0x3aa4df.removeAttribute("disabled")));
  }
  setUnavailable() {
    const _ownerProductForm = this.closest("product-form");
    const _container =
      _ownerProductForm ||
      document.getElementById("product-form-" + this.dataset.section);
    try {
      if (window && window.__PERSUVA_DEBUG) {
        console.log(
          "[variant-selects] setUnavailable: section=",
          this.dataset.section,
          " ownerFormFound=",
          !!_ownerProductForm
        );
      }
    } catch (e) {}
    if (!_container) return;
    const _0xec0894 = _container.querySelector('[name="add"]');
    const _0x3f1d56 = _container.querySelector(
      '[name="add"] .main-addtocart__label'
    );
    const _0x4b1157 = document.getElementById("price-" + this.dataset.section);
    const _0x60b70c = document.getElementById(
      "Inventory-" + this.dataset.section
    );
    const _0x313785 = document.getElementById("Sku-" + this.dataset.section);
    _0xec0894 &&
      (_0x3f1d56 && (_0x3f1d56.textContent = window.variantStrings.unavailable),
      _0x4b1157 && _0x4b1157.classList.add("visibility-hidden"),
      _0x60b70c && _0x60b70c.classList.add("visibility-hidden"),
      _0x313785 && _0x313785.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super(),
      (this.secondarySelectSelector = "variant-selects-"),
      (this.secondarySelect = document.getElementById(
        "" + this.secondarySelectSelector + this.dataset.section
      )),
      (this.isSecondary = !0);
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super(),
      (this.secondarySelectSelector = "variant-selects-"),
      (this.secondarySelect = document.getElementById(
        "" + this.secondarySelectSelector + this.dataset.section
      )),
      (this.isSecondary = !0);
  }
}
customElements.define(
  "secondary-variant-select-separate",
  SecondaryVariantSelectSeparate
);

// =========================================================================
// Global Shopify Money Formatting Setup
// =========================================================================

// Ensure Shopify object exists
window.Shopify = window.Shopify || {};

// Initialize Shopify.formatMoney if it doesn't exist
if (!window.Shopify.formatMoney) {
  // Set default money format (will be overridden by theme settings)
  window.Shopify.money_format = window.Shopify.money_format || "${{amount}}";

  window.Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }

    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Global formatMoney function that uses Shopify.formatMoney
function formatMoneyGlobal(cents, format) {
  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(cents, format);
  }
  // Fallback formatting
  return `$${(cents / 100).toFixed(2)}`;
}
